function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DS = window.WinBoostAiDesignSystem_0f78b0 || {};
var Button = DS.Button,
  IconButton = DS.IconButton,
  Icon = DS.Icon,
  Card = DS.Card,
  Badge = DS.Badge,
  CheckItem = DS.CheckItem,
  SectionLabel = DS.SectionLabel,
  Logo = DS.Logo,
  Orbit = DS.Orbit,
  Waveform = DS.Waveform,
  PatternBackdrop = DS.PatternBackdrop,
  StatBlock = DS.StatBlock,
  Field = DS.Field,
  Select = DS.Select,
  Accordion = DS.Accordion;
var A = '../../assets/';
var ICONS = A + 'icons/';
var PAT = A + 'patterns/';
var LOGOS = A + 'logos/';
function Section(_ref) {
  var id = _ref.id,
    children = _ref.children,
    style = _ref.style,
    tight = _ref.tight;
  return React.createElement("section", {
    id: id,
    className: tight ? 'sec-tight' : 'sec',
    style: style
  }, React.createElement("div", {
    className: "wrap"
  }, children));
}
function Head(_ref2) {
  var index = _ref2.index,
    label = _ref2.label,
    title = _ref2.title,
    lead = _ref2.lead,
    _ref2$align = _ref2.align,
    align = _ref2$align === void 0 ? 'left' : _ref2$align,
    inverse = _ref2.inverse;
  return React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 14,
      alignItems: align === 'center' ? 'center' : 'flex-start',
      textAlign: align,
      marginBottom: 34,
      maxWidth: align === 'center' ? 760 : 'none',
      marginLeft: align === 'center' ? 'auto' : 0,
      marginRight: align === 'center' ? 'auto' : 0
    }
  }, label && React.createElement(SectionLabel, {
    inverse: inverse,
    align: align,
    style: {
      width: align === 'center' ? 'auto' : '100%',
      maxWidth: align === 'center' ? 520 : 'none'
    }
  }, label), React.createElement("h2", {
    className: "h2 wide",
    style: inverse ? {
      color: 'var(--wb-cream)'
    } : null
  }, title), lead && React.createElement("p", {
    className: "lead",
    style: inverse ? {
      color: 'var(--text-inverse-muted)'
    } : null
  }, lead));
}
window.WB_HOME = function () {
  var home = /(^|\/)index\.html?$|\/$/.test(location.pathname);
  return function (h) {
    return home || !h || h[0] !== '#' ? h : '/'+h;
  };
}();
var NAV0 = [["L\u2019AI Phone", '#winboost-effect'], ['Fonctionnement', '#how-it-fits'], ['Essayez-le', '#hear-it'], ['Calculateur', '#calculator'], ['Tarifs', '#products'], ['Comparer', '#compare'], ['D\u00e9marrage', '#onboarding'], ['Int\u00e9grations', '#integrations'], ['Pourquoi WinBoost', '#why-winboost'], ['Avis', '#reviews']];
var NAV = typeof window !== 'undefined' && window.WB_NAV_PAGE && window.WB_NAV_PAGE.length ? window.WB_NAV_PAGE : NAV0;
var NAV_STYLE = typeof window !== 'undefined' && window.__NAV_STYLE || 'orange';
var NAV_LINK = NAV_STYLE === 'orange' ? {
  color: 'var(--orange-700)'
} : NAV_STYLE === 'gradient' ? {
  background: 'var(--grad-brand)',
  WebkitBackgroundClip: 'text',
  backgroundClip: 'text',
  color: 'transparent'
} : {
  color: 'var(--ink-700)'
};
function Nav() {
  var barRef = React.useRef(null);
  React.useEffect(function () {
    var queued = false;
    var paint = function paint() {
      queued = false;
      var el = barRef.current;
      if (!el) return;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var y = window.scrollY || 0;
      var p = max > 0 ? Math.min(1, y / max) : 0;
      el.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      el.style.opacity = y > 6 ? '1' : '0';
    };
    var onScroll = function onScroll() {
      if (!queued) {
        queued = true;
        requestAnimationFrame(paint);
      }
    };
    paint();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return function () {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return React.createElement("header", {
    style: {
      position: 'sticky',
      top: 0,
      zIndex: 50,
      height: 'var(--nav-height)',
      display: 'flex',
      alignItems: 'center'
    }
  }, React.createElement("div", {
    className: "wrap",
    style: {
      maxWidth: 1460,
      width: '100%'
    }
  }, React.createElement("style", null, '@media(max-width:1419px){html[data-wb-device=phone] .nav-links{display:none!important}}.nav-links{overflow:hidden}.nav-pill a.nav-l{color:var(--text-primary);transition:color var(--dur-fast) var(--ease-standard)}.nav-pill a.nav-l:hover{color:var(--wb-orange)}'), React.createElement("div", {
    className: "nav-pill",
    style: {
      position: 'relative',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 16,
      height: 74,
      padding: '0 8px 0 20px',
      borderRadius: 999,
      background: 'rgba(255,250,245,.94)',
      backdropFilter: 'var(--blur-nav)',
      border: '1px solid rgba(23,23,23,.08)',
      boxShadow: '0 10px 30px rgba(23,23,23,.16)'
    }
  }, React.createElement("a", {
    href: WB_HOME('#hero'),
    style: {
      display: 'flex',
      flex: '0 0 auto',
      alignItems: 'center'
    }
  }, React.createElement(Logo, {
    variant: "horizontal",
    height: 56,
    basePath: A,
    style: {
      imageRendering: 'auto'
    }
  })), React.createElement("nav", {
    className: "nav-links",
    style: {
      display: 'flex',
      gap: 'clamp(8px,.75vw,12px)',
      minWidth: 0,
      flex: '1 1 auto',
      justifyContent: 'center',
      flexWrap: 'nowrap'
    }
  }, NAV.filter(function (n) {
    return n[2] !== 2 || document.getElementById(n[1].slice(1));
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 3),
      l = _ref4[0],
      h = _ref4[1],
      loc = _ref4[2];
    return React.createElement("a", {
      key: h,
      className: "nav-l",
      href: loc ? h : WB_HOME(h),
      style: {
        fontSize: 'clamp(12.5px,.9vw,13px)',
        fontWeight: 700,
        textDecoration: 'none',
        whiteSpace: 'nowrap'
      }
    }, l);
  })), React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 14,
      flex: '0 0 auto'
    }
  }, React.createElement(Button, {
    size: "sm",
    variant: "outline",
    href: WB_HOME('#hero'),
    className: "nav-cta-2",
    style: {
      whiteSpace: 'nowrap',
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8
    }
  }, React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "15",
    height: "15",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true"
  }, React.createElement("path", {
    d: "M3.2 4.6a1.6 1.6 0 0 1 1.6-1.6h2a1.6 1.6 0 0 1 1.6 1.4l.3 2a1.6 1.6 0 0 1-.9 1.7l-.9.4a11 11 0 0 0 5 5l.4-.9a1.6 1.6 0 0 1 1.7-.9l2 .3a1.6 1.6 0 0 1 1.4 1.6v2a1.6 1.6 0 0 1-1.6 1.6A13.6 13.6 0 0 1 3.2 4.6Z"
  })), "Appeler l\u2019AI Phone"), React.createElement(Button, {
    size: "sm",
    variant: "primary",
    arrow: true,
    className: "nav-buy",
    href: window.WB_PRODUCT_HREF ? window.WB_PRODUCT_HREF('nav', 'buy-ai-phone') : WB_HOME('#pricing'),
    style: {
      whiteSpace: 'nowrap'
    }
  }, React.createElement("span", null, "Acheter", React.createElement("span", {
    className: "nb-x"
  }, " l\u2019AI Phone")))), React.createElement("div", {
    "aria-hidden": "true",
    style: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      height: 3,
      overflow: 'hidden',
      pointerEvents: 'none'
    }
  }, React.createElement("div", {
    ref: barRef,
    style: {
      height: '100%',
      width: '100%',
      transform: 'scaleX(0)',
      transformOrigin: 'left center',
      opacity: 0,
      background: 'var(--grad-brand)',
      transition: 'opacity var(--dur-base) var(--ease-standard)'
    }
  })))));
}
var G = {
  phone: 'M6.8 3.6 9 8.2l-1.9 1.5a11 11 0 0 0 5.2 5.2l1.5-1.9 4.6 2.2-.6 3a1.5 1.5 0 0 1-1.7 1.2C9.5 18.4 5.6 14.5 3.4 6.9a1.5 1.5 0 0 1 1.2-1.7Z',
  bolt: 'M13 2 4.5 13H11l-1 9 8.5-11H12Z',
  users: 'M8.5 11a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4ZM2.5 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5M16.2 10.7a2.8 2.8 0 1 0 0-5.6M17.5 14.8c2.4.5 4 2.4 4 5.2',
  chat: 'M21 11.5a7.5 7.5 0 0 1-11.2 6.5L3.5 20l1.9-5.8A7.5 7.5 0 1 1 21 11.5Z',
  cal: 'M4 6.5h16v14H4zM4 10.5h16M8.5 3v4M15.5 3v4',
  card: 'M2.5 6.5h19v11h-19zM2.5 10.5h19M6 14.5h4',
  send: 'M21.5 2.5 2.5 10.2l7.6 2.9 2.9 7.6ZM10.1 13.1 21.5 2.5',
  star: 'M12 3.2l2.7 5.6 6 .8-4.4 4.2 1.1 6-5.4-2.9-5.4 2.9 1.1-6L3.3 9.6l6-.8Z',
  search: 'M10.8 18.2a7.4 7.4 0 1 0 0-14.8 7.4 7.4 0 0 0 0 14.8ZM16.4 16.4 21 21',
  spark: 'M12 2.5 14 8l5.5 2-5.5 2-2 5.5-2-5.5L4.5 10 10 8ZM19 16l.9 2.4 2.4.9-2.4.9-.9 2.4-.9-2.4-2.4-.9 2.4-.9Z',
  bars: 'M4 20V12M10 20V4M16 20V9M22 20H2',
  globe: 'M12 21.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19ZM2.5 12h19M12 2.5c2.6 2.7 4 6 4 9.5s-1.4 6.8-4 9.5c-2.6-2.7-4-6-4-9.5s1.4-6.8 4-9.5Z',
  mic: 'M12 15a3.5 3.5 0 0 0 3.5-3.5v-6a3.5 3.5 0 1 0-7 0v6A3.5 3.5 0 0 0 12 15ZM5 11.5a7 7 0 0 0 14 0M12 15v6.5M8.5 21.5h7',
  funnel: 'M2.5 4.5h19l-7.2 8v7l-4.6 2.5v-9.5Z',
  infin: 'M8.4 8.4a5 5 0 1 0 0 7.2c2-2 3.2-5.2 5.2-7.2a5 5 0 1 1 0 7.2c-2-2-3.2-5.2-5.2-7.2Z',
  chart: 'M4 20V4h16v16zM8 16.5V11M12 16.5V7.5M16 16.5v-3'
};
function Glyph(_ref5) {
  var d = _ref5.d,
    _ref5$size = _ref5.size,
    size = _ref5$size === void 0 ? 17 : _ref5$size,
    _ref5$color = _ref5.color,
    color = _ref5$color === void 0 ? 'var(--wb-white)' : _ref5$color;
  return React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true",
    style: {
      flex: '0 0 auto',
      display: 'block'
    }
  }, React.createElement("path", {
    d: d,
    stroke: color,
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
function TypedHeadline(_ref6) {
  var lines = _ref6.lines,
    _ref6$cps = _ref6.cps,
    cps = _ref6$cps === void 0 ? 95 : _ref6$cps,
    _ref6$delay = _ref6.delay,
    delay = _ref6$delay === void 0 ? 140 : _ref6$delay,
    _ref6$linePause = _ref6.linePause,
    linePause = _ref6$linePause === void 0 ? 0 : _ref6$linePause,
    style = _ref6.style;
  var reduced = typeof matchMedia !== 'undefined' && matchMedia('(prefers-reduced-motion:reduce)').matches;
  var L1 = lines[0].length,
    total = Math.max.apply(Math, _toConsumableArray(lines.map(function (l) {
      return l.length;
    })));
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    started = _React$useState2[0],
    setStarted = _React$useState2[1];
  var _React$useState3 = React.useState(0),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    n = _React$useState4[0],
    setN = _React$useState4[1];
  var finished = React.useRef(false);
  var canAnimate = !reduced && typeof requestAnimationFrame === 'function';
  React.useLayoutEffect(function () {
    if (canAnimate && !document.hidden) setStarted(true);
  }, [canAnimate]);
  React.useEffect(function () {
    if (!canAnimate) return;
    var raf = null,
      t0 = null;
    var per = 1000 / cps;
    var _step = function step(ts) {
      if (t0 === null) t0 = ts;
      var ms = ts - t0 - delay;
      var c = ms > 0 ? Math.min(total, Math.floor(ms / per)) : 0;
      setN(c);
      if (c < total) {
        raf = requestAnimationFrame(_step);
      } else {
        raf = null;
        finished.current = true;
      }
    };
    var start = function start() {
      if (finished.current || raf !== null || document.hidden) return;
      t0 = null;
      setStarted(true);
      raf = requestAnimationFrame(_step);
    };
    start();
    document.addEventListener('visibilitychange', start);
    return function () {
      if (raf) cancelAnimationFrame(raf);
      document.removeEventListener('visibilitychange', start);
    };
  }, [L1, total, cps, delay, linePause, canAnimate]);
  var revealAll = !started;
  var done = revealAll || n >= total;
  var seen = 0;
  return React.createElement("h1", {
    style: _objectSpread({
      fontSize: 'var(--fs-display-1)',
      lineHeight: 1.04,
      letterSpacing: 'var(--ls-display-1)',
      fontWeight: 800,
      textAlign: 'center'
    }, style)
  }, lines.map(function (line, li) {
    return React.createElement("span", {
      key: li,
      style: {
        display: 'block',
        color: 'var(--wb-white)'
      }
    }, line.split('').map(function (ch, ci) {
      var shown = revealAll || ci < n;
      return React.createElement("span", {
        key: ci,
        style: {
          whiteSpace: 'pre-wrap',
          opacity: shown ? 1 : 0,
          transition: 'opacity 50ms linear'
        }
      }, ch, !done && ci === n - 1 && React.createElement("span", {
        style: {
          position: 'relative'
        }
      }, React.createElement("span", {
        style: {
          position: 'absolute',
          left: 3,
          top: '0.29em',
          height: '0.9em',
          width: 4,
          borderRadius: 2,
          background: 'var(--wb-white)'
        }
      })));
    }));
  }));
}
function Firework(_ref7) {
  var dir = _ref7.dir,
    x = _ref7.x,
    reach = _ref7.reach;
  var N = 32;
  return React.createElement("span", {
    className: "wb-hfw",
    "aria-hidden": "true",
    style: {
      top: '50%',
      left: 'calc(50% + ' + dir * x + 'px)'
    }
  }, React.createElement("b", {
    style: {
      '--lift': '120px'
    }
  }), Array.from({
    length: N
  }, function (_, q) {
    var ang = (-125 + 250 / (N - 1) * q) * Math.PI / 180,
      r = reach * (0.62 + q % 5 * 0.095);
    return React.createElement("i", {
      key: q,
      style: {
        '--tx': (Math.cos(ang) * r * dir).toFixed(1) + 'px',
        '--ty': (Math.sin(ang) * r * .62 - 8).toFixed(1) + 'px',
        background: q % 3 === 0 ? 'var(--wb-gold)' : q % 3 === 1 ? 'var(--wb-orange)' : 'var(--wb-cream)',
        animationDelay: .3 + q % 6 * .03 + 's'
      }
    });
  }));
}
function Orbit3DStage(_ref8) {
  var listening = _ref8.listening,
    onTap = _ref8.onTap;
  var frame = React.useRef(null);
  var _React$useState5 = React.useState(function () {
      return window.WB_ORBIT3D.html({
        scale: 1.12,
        bare: true
      });
    }),
    _React$useState6 = _slicedToArray(_React$useState5, 1),
    doc = _React$useState6[0];
  var latest = React.useRef({
    listening: listening,
    onTap: onTap
  });
  latest.current = {
    listening: listening,
    onTap: onTap
  };
  var send = React.useCallback(function () {
    var w = frame.current && frame.current.contentWindow;
    if (w) w.postMessage({
      type: 'wb-sel',
      sel: latest.current.listening ? {
        "in": true,
        out: true
      } : {}
    }, '*');
  }, []);
  React.useEffect(function () {
    var on = function on(e) {
      if (!frame.current || e.source !== frame.current.contentWindow || !e.data) return;
      if (e.data.type === 'wb-ready') send();
      if (e.data.type === 'wb-tap' && latest.current.onTap) latest.current.onTap();
    };
    window.addEventListener('message', on);
    return function () {
      return window.removeEventListener('message', on);
    };
  }, [send]);
  React.useEffect(send, [listening, send]);
  return React.createElement("div", {
    className: "wb-orbit3d",
    style: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 auto',
      alignSelf: 'stretch',
      width: '100%',
      minHeight: 300,
      borderRadius: 22,
      overflow: 'hidden',
      cursor: 'pointer',
      background: 'radial-gradient(circle at 50% 42%,var(--ink-800) 0%,var(--wb-charcoal) 68%)',
      boxShadow: 'inset 0 0 0 1px var(--border-inverse),0 20px 44px -26px color-mix(in srgb,var(--wb-charcoal) 75%,transparent)'
    }
  }, React.createElement("div", {
    style: {
      position: 'relative',
      flex: '1 1 auto',
      minHeight: 0,
      WebkitMaskImage: 'linear-gradient(180deg,#000 0,#000 88%,transparent 100%)',
      maskImage: 'linear-gradient(180deg,#000 0,#000 88%,transparent 100%)'
    }
  }, React.createElement("iframe", {
    ref: frame,
    title: "Le logo WinBoost AI Phone qui tourne en 3D",
    srcDoc: doc,
    onLoad: send,
    style: {
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      border: 0,
      background: 'transparent'
    }
  })), React.createElement("div", {
    "aria-live": "polite",
    onClick: onTap,
    style: {
      flex: '0 0 auto',
      padding: '10px 16px 14px',
      textAlign: 'center'
    }
  }, React.createElement("span", {
    style: {
      display: 'block',
      fontSize: 11.5,
      fontWeight: 800,
      letterSpacing: '.14em',
      textTransform: 'uppercase',
      color: 'var(--wb-gold)'
    }
  }, listening ? '\u00c0 l\u2019\u00e9coute' : 'Touchez l\u2019AI Phone pour parler'), React.createElement("span", {
    style: {
      display: 'block',
      marginTop: 3,
      fontSize: 13.5,
      lineHeight: 1.3,
      fontWeight: 700,
      color: 'var(--wb-white)'
    }
  }, listening ? 'Parlez maintenant, notre r\u00e9ceptionniste IA est en ligne.' : 'Essayez notre AI Phone\u00a0: parlez \u00e0 notre r\u00e9ceptionniste IA.')));
}
function HfHuman(_ref9) {
  var _ref9$size = _ref9.size,
    size = _ref9$size === void 0 ? 26 : _ref9$size;
  return React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 26 26",
    fill: "none",
    "aria-hidden": "true"
  }, React.createElement("circle", {
    cx: "13",
    cy: "9",
    r: "4",
    stroke: "var(--wb-orange)",
    strokeWidth: "1.6"
  }), React.createElement("path", {
    d: "M5 22c0-4.5 3.6-8 8-8s8 3.5 8 8",
    stroke: "var(--wb-orange)",
    strokeWidth: "1.6",
    strokeLinecap: "round"
  }));
}
function HfDemo(_ref0) {
  var items = _ref0.items,
    demo = _ref0.demo,
    live = _ref0.live;
  var N = items.length,
    T = 2.6;
  var _React$useState7 = React.useState(0),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    active = _React$useState8[0],
    setActive = _React$useState8[1];
  var _React$useState9 = React.useState(0),
    _React$useState0 = _slicedToArray(_React$useState9, 2),
    sec = _React$useState0[0],
    setSec = _React$useState0[1];
  var box = React.useRef(null);
  React.useEffect(function () {
    var reduced = typeof matchMedia !== 'undefined' && matchMedia('(prefers-reduced-motion:reduce)').matches;
    if (reduced) return;
    var vis = true;
    var io = typeof IntersectionObserver !== 'undefined' && box.current ? new IntersectionObserver(function (es) {
      vis = es[es.length - 1].isIntersecting;
    }, {
      rootMargin: '100px'
    }) : null;
    if (io) io.observe(box.current);
    var start = performance.now();
    var id = setInterval(function () {
      if (!vis) return;
      var el = (performance.now() - start) / 1000;
      setActive(Math.floor(el / T) % N);
      setSec(Math.floor(el % (N * T)));
    }, 250);
    return function () {
      clearInterval(id);
      if (io) io.disconnect();
    };
  }, [N]);
  var lines = demo[active] || demo[0];
  return React.createElement(React.Fragment, null, React.createElement("div", {
    ref: box,
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 9,
      margin: '2px 0 8px'
    }
  }, React.createElement(HfHuman, {
    size: 26
  }), React.createElement("div", {
    style: {
      flex: 1,
      minWidth: 40
    }
  }, React.createElement(SoundRibbon, {
    height: 18,
    active: true
  })), React.createElement(Orbit, {
    size: 26,
    state: "speaking",
    basePath: A
  })), React.createElement("span", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      alignSelf: 'flex-start',
      marginBottom: 8,
      padding: '4px 9px',
      borderRadius: 999,
      background: 'rgba(22,140,90,.18)',
      color: '#5FD695',
      fontSize: 11,
      fontWeight: 800,
      letterSpacing: '.01em'
    }
  }, React.createElement("span", {
    "aria-hidden": "true",
    style: {
      width: 6,
      height: 6,
      borderRadius: '50%',
      background: '#5FD695',
      flex: 'none'
    }
  }), live, " \u00b7 en direct", live !== 'Demande d\u2019avis' && React.createElement(React.Fragment, null, " \xB7 ", Math.floor(sec / 60), ":", String(sec % 60).padStart(2, '0'))), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
      height: 116,
      justifyContent: 'center',
      overflow: 'hidden',
      marginBottom: 9
    }
  }, lines.map(function (_ref1, li) {
    var _ref10 = _slicedToArray(_ref1, 3),
      who = _ref10[0],
      txt = _ref10[1],
      ai = _ref10[2];
    return React.createElement("div", {
      key: li,
      style: {
        display: 'flex',
        gap: 8,
        alignItems: 'flex-start'
      }
    }, React.createElement("span", {
      className: "mono",
      style: {
        color: ai ? 'var(--wb-orange)' : '#8A8A8A',
        fontSize: 10,
        width: 56,
        flex: 'none',
        paddingTop: 3,
        whiteSpace: 'nowrap'
      }
    }, who), React.createElement("span", {
      style: {
        fontSize: 12,
        lineHeight: 1.4,
        color: '#FFFAF5',
        background: ai ? 'rgba(252,99,6,.14)' : '#292929',
        border: '1px solid ' + (ai ? 'rgba(252,99,6,.5)' : '#3A3A3A'),
        borderRadius: 9,
        padding: '6px 9px'
      }
    }, "\u201C", txt, "\u201D"));
  })), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2,minmax(0,1fr))',
      gap: 6,
      paddingTop: 8,
      borderTop: '1px solid rgba(255,250,245,.14)'
    }
  }, items.map(function (_ref11, ri) {
    var _ref12 = _slicedToArray(_ref11, 2),
      d = _ref12[0],
      t = _ref12[1];
    return React.createElement("span", {
      key: t,
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        minWidth: 0,
        background: ri === active ? 'rgba(252,99,6,.14)' : '#0e0e0e',
        boxShadow: ri === active ? 'inset 0 0 0 1px var(--wb-orange)' : 'none',
        borderRadius: 8,
        padding: '5px 7px',
        minHeight: 34,
        boxSizing: 'border-box',
        transition: 'background .35s ease,box-shadow .35s ease'
      }
    }, React.createElement(Glyph, {
      d: d,
      size: 13,
      color: "var(--wb-orange)"
    }), React.createElement("span", {
      style: {
        fontSize: 11.5,
        lineHeight: 1.2,
        fontWeight: 700,
        color: '#FFFAF5',
        minWidth: 0
      }
    }, t));
  })));
}
function HeroPath() {
  var icon = function icon(f) {
    return A + 'icons/' + f;
  };
  var VM = 'M6.5 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM17.5 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM6.5 15.5h11';
  var DOWN = 'M3 7.5l6 6 4-4 8 8M21 12.5v5h-5';
  var PHONE = 'M6.8 3.6 9 8.2l-1.9 1.5a11 11 0 0 0 5.2 5.2l1.5-1.9 4.6 2.2-.6 3a1.5 1.5 0 0 1-1.7 1.2C9.5 18.4 5.6 14.5 3.4 6.9a1.5 1.5 0 0 1 1.2-1.7Z';
  var LB = 'D\u00e9sactiv\u00e9|Activ\u00e9'.split('|');
  var Pill = function Pill(_ref13) {
    var img = _ref13.img,
      glyph = _ref13.glyph,
      gc = _ref13.gc,
      orb = _ref13.orb,
      t = _ref13.t,
      cls = _ref13.cls;
    var _t$split = t.split('|'),
      _t$split2 = _slicedToArray(_t$split, 2),
      b = _t$split2[0],
      s = _t$split2[1];
    return React.createElement("span", {
      className: 'hp-pill' + (cls ? ' ' + cls : '')
    }, img && React.createElement("img", {
      src: icon(img),
      alt: "",
      width: "22",
      height: "22"
    }), glyph && React.createElement(Glyph, {
      d: glyph,
      size: 18,
      color: gc || 'currentColor'
    }), orb && React.createElement("span", {
      className: "hp-orb"
    }, React.createElement(Orbit, {
      size: 22,
      state: "breathing",
      basePath: A
    })), React.createElement("span", {
      className: "hp-txt"
    }, React.createElement("b", null, b), s ? ' ' : null, s ? React.createElement("span", null, s) : null));
  };
  var Arr = function Arr() {
    return React.createElement("svg", {
      className: "hp-arr",
      width: "16",
      height: "10",
      viewBox: "0 0 16 10",
      "aria-hidden": "true"
    }, React.createElement("path", {
      d: "M1 5h13M10 1l4 4-4 4",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  };
  var _React$useState1 = React.useState(0),
    _React$useState10 = _slicedToArray(_React$useState1, 2),
    v = _React$useState10[0],
    setV = _React$useState10[1];
  var vr = React.useRef(0),
    raf = React.useRef(0),
    touched = React.useRef(false),
    st = React.useRef(null),
    root = React.useRef(null),
    bx = React.useRef(null);
  var set = function set(x) {
    vr.current = x;
    setV(x);
  };
  var go = function go(to) {
    cancelAnimationFrame(raf.current);
    var from = vr.current,
      t0 = performance.now(),
      d = Math.max(220, Math.abs(to - from) * 9);
    var _step2 = function step(t) {
      var k = Math.min(1, (t - t0) / d),
        e = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
      set(from + (to - from) * e);
      if (k < 1) raf.current = requestAnimationFrame(_step2);
    };
    raf.current = requestAnimationFrame(_step2);
  };
  React.useEffect(function () {
    var el = root.current;
    if (!el) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      set(100);
      return;
    }
    var tm = 0;
    if (!('IntersectionObserver' in window)) {
      tm = setTimeout(function () {
        if (!touched.current) go(100);
      }, 900);
      return function () {
        return clearTimeout(tm);
      };
    }
    var io = new IntersectionObserver(function (es) {
      if (es.some(function (e) {
        return e.isIntersecting;
      })) {
        io.disconnect();
        tm = setTimeout(function () {
          if (!touched.current) go(100);
        }, 900);
      }
    }, {
      threshold: .5
    });
    io.observe(el);
    return function () {
      io.disconnect();
      clearTimeout(tm);
      cancelAnimationFrame(raf.current);
    };
  }, []);
  var pos = function pos(e) {
    var b = bx.current.getBoundingClientRect();
    return Math.max(0, Math.min(100, (e.clientX - b.left) / b.width * 100));
  };
  var down = function down(e) {
    st.current = {
      x: e.clientX,
      y: e.clientY,
      id: e.pointerId,
      drag: false
    };
  };
  var move = function move(e) {
    var s = st.current;
    if (!s) return;
    if (!s.drag) {
      var dx = Math.abs(e.clientX - s.x),
        dy = Math.abs(e.clientY - s.y);
      if (dx > 6 && dx > dy) {
        s.drag = true;
        touched.current = true;
        cancelAnimationFrame(raf.current);
        try {
          e.currentTarget.setPointerCapture(s.id);
        } catch (_) {}
      } else return;
    }
    set(pos(e));
  };
  var up = function up() {
    var s = st.current;
    st.current = null;
    if (!s) return;
    touched.current = true;
    go(s.drag ? vr.current >= 50 ? 100 : 0 : vr.current >= 50 ? 0 : 100);
  };
  var cancel = function cancel() {
    var s = st.current;
    st.current = null;
    if (s && s.drag) go(vr.current >= 50 ? 100 : 0);
  };
  var on = v >= 50;
  return React.createElement("div", {
    className: "hp-wrap"
  }, React.createElement("style", null, '.hp{display:flex;flex-direction:column;align-items:center;gap:10px;margin:4px auto 0;width:100%;max-width:760px;color:var(--wb-white)}.hp-pill{position:relative;display:inline-flex;align-items:center;gap:7px;padding:6px 12px 6px 8px;border-radius:999px;background:var(--wb-white);color:var(--text-primary);box-shadow:0 10px 22px -14px rgba(92,36,4,.6);white-space:nowrap;font-size:14px;line-height:1.2}.hp-pill img{width:22px;height:22px;flex:none;display:block}.hp-orb{display:inline-flex;width:22px;height:22px;flex:none}.hp-txt b{font-weight:800}.hp-txt span{display:none}.hp-start{padding:9px 18px;font-size:15px;background:var(--wb-charcoal,#171717);color:var(--wb-white)}.hp-top{display:flex;align-items:center;justify-content:center;gap:8px;flex-wrap:wrap}.hp-arr{flex:none;color:rgba(255,255,255,.9)}.hp-ctl{display:flex;align-items:center;gap:10px;font-weight:800;font-size:14px;line-height:1}.hp-lb{min-width:5.2em;text-align:left;font-size:13px;letter-spacing:.04em}.hp-ctl>b{min-width:5.2em;text-align:right;font-weight:800}.hp-sw{position:relative;width:50px;height:28px;border-radius:99px;border:0;padding:0;margin:0;background:rgba(255,255,255,.35);cursor:pointer;flex:none;transition:background .25s}.hp-sw:after{content:"";position:absolute;top:3px;left:3px;width:22px;height:22px;border-radius:50%;background:#fff;box-shadow:0 2px 6px rgba(0,0,0,.2);transition:left .25s}.hp-sw.on{background:#22A86C}.hp-sw.on:after{left:25px}.hp-sw:focus-visible{outline:2px solid #fff;outline-offset:3px}.hp-box{position:relative;display:grid;width:100%;border-radius:16px;overflow:hidden;cursor:ew-resize;touch-action:pan-y;-webkit-user-select:none;user-select:none;box-shadow:0 14px 30px -18px rgba(92,36,4,.7)}.hp-ly{grid-area:1/1;display:flex;align-items:center;justify-content:center;gap:8px;padding:14px;flex-wrap:wrap}.hp-off{background-color:#C9561A;background-image:repeating-linear-gradient(-45deg,rgba(92,58,34,.2) 0 2px,transparent 2px 8px)}.hp-off .hp-pill{background:rgba(255,255,255,.5);color:#5C3A22;box-shadow:none}.hp-on{background:var(--wb-white)}.hp-on .hp-pill{background:#FFF2E8;box-shadow:inset 0 0 0 1.5px #FC6306}.hp-on .hp-arr{color:#FC6306}.hp-tag{display:inline-flex;align-items:center;gap:6px;font-size:11px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;white-space:nowrap}.hp-tag:before{display:inline-grid;place-items:center;flex:none;width:16px;height:16px;border-radius:50%;font-size:10px;font-weight:900;letter-spacing:0;line-height:1;color:#fff}.hp-off .hp-tag{color:#fff}.hp-off .hp-tag:before{content:"✕";background:#D93A2B}.hp-on .hp-tag{color:#1D7A4E}.hp-on .hp-tag:before{content:"✓";background:#22A86C}.hp-hd{position:absolute;top:0;bottom:0;width:3px;margin-left:-1.5px;background:#fff;pointer-events:none;box-shadow:0 0 0 1px rgba(92,36,4,.15)}.hp-hd:after{content:"⇆";position:absolute;top:50%;left:50%;width:28px;height:28px;margin:-14px 0 0 -14px;border-radius:50%;background:#fff;color:#171717;display:grid;place-items:center;font-size:14px;font-weight:800;box-shadow:0 2px 8px rgba(0,0,0,.25)}.hp-cta{margin:8px 0 0;text-align:center;font-size:var(--fs-body-lg);line-height:var(--lh-body-lg)}@media (max-width:1099px){.hp-ly{flex-direction:column;gap:5px}.hp-ly .hp-arr{transform:rotate(90deg)}}@media (min-width:1100px){.hp{max-width:1040px}.hp-ly{flex-wrap:nowrap}.hp-ly .hp-pill:last-child{white-space:normal;max-width:340px;text-align:left}}@media (max-width:600px){.hp{gap:8px}.hp-top{flex-direction:column;gap:4px}.hp-top .hp-arr,.hp-ly .hp-arr{transform:rotate(90deg)}.hp-start{font-size:13.5px;padding:7px 14px}.hp-pill{font-size:12.5px;gap:6px;padding:5px 11px 5px 7px;white-space:normal;text-align:left}.hp-pill img,.hp-orb{width:18px;height:18px}.hp-ly{flex-direction:column;gap:4px;padding:8px 6px}.hp-tag{flex-basis:auto}.hp-ctl{font-size:13px}}.hp-top .hp-pill{font-size:15px;padding:9px 18px;box-sizing:border-box;min-height:38px}.hp-top .hp-call{padding-left:14px}@media (max-width:600px){.hp-top .hp-pill{font-size:14px;padding:7px 15px;min-height:34px}.hp-top .hp-call{padding-left:10px}}'), React.createElement("div", {
    className: "hp",
    ref: root
  }, React.createElement("div", {
    className: "hp-top"
  }, React.createElement(Pill, {
    t: "Vous amenez le trafic, puis\u2026",
    cls: "hp-start"
  }), React.createElement(Arr, null), React.createElement(Pill, {
    glyph: PHONE,
    gc: "#22A86C",
    t: "Un lead appelle",
    cls: "hp-call"
  })), React.createElement("div", {
    className: "hp-ctl"
  }, React.createElement("b", null, "WinBoost"), React.createElement("button", {
    type: "button",
    className: 'hp-sw' + (on ? ' on' : ''),
    role: "switch",
    "aria-checked": on,
    "aria-label": "WinBoost",
    onClick: function onClick() {
      touched.current = true;
      go(on ? 0 : 100);
    }
  }), React.createElement("span", {
    className: "hp-lb"
  }, on ? LB[1] : LB[0])), React.createElement("div", {
    className: "hp-box",
    ref: bx,
    onPointerDown: down,
    onPointerMove: move,
    onPointerUp: up,
    onPointerCancel: cancel
  }, React.createElement("div", {
    className: "hp-ly hp-off"
  }, React.createElement("span", {
    className: "hp-tag"
  }, "Sans WinBoost"), React.createElement(Arr, null), React.createElement(Pill, {
    glyph: VM,
    t: "Bo\u00eete vocale|aucune r\u00e9ponse"
  }), React.createElement(Arr, null), React.createElement(Pill, {
    glyph: DOWN,
    t: "Lead perdu|argent gaspill\u00e9"
  })), React.createElement("div", {
    className: "hp-ly hp-on",
    style: {
      clipPath: 'inset(0 ' + (100 - v) + '% 0 0)',
      WebkitClipPath: 'inset(0 ' + (100 - v) + '% 0 0)'
    }
  }, React.createElement("span", {
    className: "hp-tag"
  }, "Avec WinBoost"), React.createElement(Arr, null), React.createElement(Pill, {
    orb: true,
    t: "L\u2019AI Phone WinBoost r\u00e9pond 24/7"
  }), React.createElement(Arr, null), React.createElement(Pill, {
    img: "money-bag.png",
    t: "Votre AI Phone sur mesure r\u00e9serve vos leads et encaisse les paiements"
  })), v > 0 && v < 100 && React.createElement("span", {
    className: "hp-hd",
    style: {
      left: v + '%'
    },
    "aria-hidden": "true"
  }))), React.createElement("p", {
    className: "hp-cta"
  }, React.createElement("strong", {
    style: {
      color: 'var(--wb-white)',
      fontWeight: 800
    }
  }, "Essayez l\u2019AI Phone ici \u2193")));
}
function Hero(_ref14) {
  var bubbles = _ref14.bubbles;
  var _React$useState11 = React.useState('breathing'),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    state = _React$useState12[0],
    setState = _React$useState12[1];
  var has3d = !!(window.WB_ORBIT3D && window.WB_ORBIT3D.html);
  var _React$useState13 = React.useState({
      name: '',
      business: '',
      phone: '',
      email: ''
    }),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    form = _React$useState14[0],
    setForm = _React$useState14[1];
  var _React$useState15 = React.useState(false),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    open = _React$useState16[0],
    setOpen = _React$useState16[1];
  var _React$useState17 = React.useState([]),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    picks = _React$useState18[0],
    setPicks = _React$useState18[1];
  var PRODUCTS = ['AI Phone appels entrants', 'AI Phone appels sortants', 'SMS IA'];
  var toggle = function toggle(p) {
    return setPicks(function (v) {
      return v.includes(p) ? v.filter(function (x) {
        return x !== p;
      }) : [].concat(_toConsumableArray(v), [p]);
    });
  };
  var _React$useState19 = React.useState('idle'),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    status = _React$useState20[0],
    setStatus = _React$useState20[1];
  var _React$useState21 = React.useState(false),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    burst = _React$useState22[0],
    setBurst = _React$useState22[1];
  var onAssembled = React.useCallback(function () {
    setBurst(false);
    requestAnimationFrame(function () {
      setBurst(true);
      setTimeout(function () {
        return setBurst(false);
      }, 1900);
    });
  }, []);
  var stageRef = React.useRef(null);
  var _React$useState23 = React.useState({
      w: 0,
      h: 0
    }),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    stage = _React$useState24[0],
    setStage = _React$useState24[1];
  React.useLayoutEffect(function () {
    var el = stageRef.current;
    if (!el) return;
    var measure = function measure() {
      var r = el.getBoundingClientRect();
      if (r.width > 0) setStage(function (s) {
        return s.w === r.width && s.h === r.height ? s : {
          w: r.width,
          h: r.height
        };
      });
    };
    measure();
    var id = requestAnimationFrame(measure);
    if (!window.ResizeObserver) {
      window.addEventListener('resize', measure);
      return function () {
        cancelAnimationFrame(id);
        window.removeEventListener('resize', measure);
      };
    }
    var ro = new ResizeObserver(function (_ref15) {
      var _ref16 = _slicedToArray(_ref15, 1),
        e = _ref16[0];
      return setStage({
        w: e.contentRect.width,
        h: e.contentRect.height
      });
    });
    ro.observe(el);
    return function () {
      cancelAnimationFrame(id);
      ro.disconnect();
    };
  }, []);
  var orbSize = Math.round(Math.max(140, Math.min(380, stage.w * 0.49, (stage.h || 380) - 8)));
  var free = Math.max(0, stage.w / 2 - orbSize / 2);
  var fwX = Math.round(orbSize / 2 + free / 2);
  var fwReach = Math.round(Math.min(free * 0.62, 200));
  var set = function set(k) {
    return function (e) {
      return setForm(_objectSpread(_objectSpread({}, form), {}, _defineProperty({}, k, e.target.value)));
    };
  };
  var submit = function () {
    var _ref17 = _asyncToGenerator(_regenerator().m(function _callee(e) {
      var r;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            e.preventDefault();
            if (!(status === 'sending')) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            setStatus('sending');
            _context.n = 2;
            return window.wbSubmitLead(_objectSpread(_objectSpread({}, form), {}, {
              interestedIn: picks
            }), 'hero');
          case 2:
            r = _context.v;
            setStatus(r.ok ? 'sent' : 'error');
            if (r.ok) {
              setForm({
                name: '',
                business: '',
                phone: '',
                email: ''
              });
              setPicks([]);
            }
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function submit(_x) {
      return _ref17.apply(this, arguments);
    };
  }();
  var talk = function talk() {
    var dest = window.WB_AGENT_CALL;
    if (dest) {
      window.open(dest, dest.slice(0, 4) === 'tel:' ? '_self' : '_blank', 'noopener');
      return;
    }
    setState(state === 'listening' ? 'breathing' : 'listening');
  };
  return React.createElement("section", {
    id: "hero",
    style: {
      position: 'relative',
      overflow: 'hidden',
      marginTop: 'calc(var(--nav-height) * -1)',
      paddingTop: 'calc(var(--nav-height) + 14px)',
      paddingBottom: 20,
      minHeight: '100svh',
      display: 'flex',
      flexDirection: 'column',
      background: 'linear-gradient(158deg,var(--orange-500) 0%,var(--orange-600) 44%,var(--orange-700) 100%)'
    }
  }, React.createElement("style", null, '@keyframes wbTapNudge{0%,100%{transform:translateY(2px);opacity:.5}50%{transform:translateY(-3px);opacity:1}}.wb-hfw{position:absolute;width:0;height:0;pointer-events:none;z-index:4}.wb-hfw i{position:absolute;left:0;top:0;width:11px;height:11px;margin:-5.5px;border-radius:50%;opacity:0;animation:wbHeroSpark 1.35s cubic-bezier(.15,.7,.35,1) forwards}@keyframes wbHeroSpark{0%{transform:translate(0,0) scale(.4);opacity:0}12%{opacity:1;transform:translate(calc(var(--tx)*.18),calc(var(--ty)*.18)) scale(1.1)}70%{opacity:1}100%{transform:translate(var(--tx),calc(var(--ty) + 16px)) scale(.25);opacity:0}}.wb-hfw b{position:absolute;left:0;top:0;width:5px;height:24px;margin:-12px -2.5px;border-radius:2px;background:linear-gradient(180deg,var(--wb-cream),var(--wb-gold) 45%,rgba(244,138,29,0));box-shadow:0 0 10px rgba(244,138,29,.85);animation:wbHeroLaunch .3s cubic-bezier(.2,.55,.3,1) forwards}@keyframes wbHeroLaunch{0%{transform:translateY(var(--lift,90px)) scaleY(.5);opacity:0}18%{opacity:1}82%{opacity:1;transform:translateY(calc(var(--lift,90px)*.14)) scaleY(1.2)}100%{transform:translateY(0) scaleY(.35);opacity:0}}@media(prefers-reduced-motion:reduce){.wb-hfw{display:none}}#hero h1{font-size:clamp(22px,2.5vw,36px)!important;max-width:986px}#hero .wrap>p{font-size:clamp(14px,1.2vw,18px)!important;line-height:1.5!important;max-width:1060px}.hf-card{transform-origin:50% 0;animation:hfDeploy .75s cubic-bezier(.2,.8,.25,1) both;animation-delay:calc(.35s + var(--ci)*.16s)}.hf-head{animation:hfFade .5s ease-out both;animation-delay:calc(.6s + var(--ci)*.16s)}.hf-head>span:first-child{animation:hfPop .55s cubic-bezier(.3,1.6,.5,1) both;animation-delay:calc(.65s + var(--ci)*.16s)}.hf-row{animation:hfRow .5s cubic-bezier(.2,.8,.25,1) both;animation-delay:calc(.8s + var(--ci)*.16s + var(--ri)*.08s)}@keyframes hfDeploy{0%{opacity:0;transform:translateY(34px) scaleY(.35);box-shadow:0 0 0 rgba(92,36,4,0)}60%{opacity:1}100%{opacity:1;transform:none}}@keyframes hfFade{0%{opacity:0;transform:translateY(-6px)}100%{opacity:1;transform:none}}@keyframes hfPop{0%{transform:scale(0) rotate(-90deg)}100%{transform:none}}@keyframes hfRow{0%{opacity:0;transform:translateX(-14px)}100%{opacity:1;transform:none}}@media(prefers-reduced-motion:reduce){.hf-card,.hf-head,.hf-head>span:first-child,.hf-row{animation:none}}'), React.createElement("div", {
    "aria-hidden": "true",
    style: {
      position: 'absolute',
      inset: 0,
      pointerEvents: 'none',
      backgroundImage: 'radial-gradient(rgba(255,255,255,' + (bubbles ? .1 : .22) + ') 1px,transparent 1px)',
      backgroundSize: '24px 24px'
    }
  }), bubbles === 'low' && React.createElement(BubbleField, {
    reach: .44,
    targetY: .6,
    density: 1
  }), bubbles === 'high' && React.createElement(BubbleField, {
    reach: .75,
    targetY: .58,
    density: 1.35
  }), React.createElement("div", {
    className: "wrap",
    style: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 6,
      flex: '1 1 auto',
      minHeight: 0
    }
  }, React.createElement(TypedHeadline, {
    lines: ['WinBoost AI Phone Lead Closer', 'Le seul AI Phone con\u00e7u pour g\u00e9n\u00e9rer des revenus de fa\u00e7on autonome.']
  }), !has3d && React.createElement("div", {
    className: "hero-feats",
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3,minmax(0,1fr))',
      gap: 12,
      width: '100%',
      maxWidth: 1120,
      textAlign: 'left'
    }
  }, [['\u00c0 chaque appel', 'Du bonjour \u00e0 la conclusion', G.phone, 'R\u00e9servation', [[G.bolt, 'R\u00e9pond instantan\u00e9ment'], [G.users, 'Qualifie les leads'], [G.chat, 'G\u00e8re les objections'], [G.cal, 'Prend les rendez-vous'], [G.card, 'Capture les paiements'], [G.send, 'Envoie des textos pendant l\u2019appel et pour le suivi']], [[['Appelant', 'Hi!'], ['AI Phone', "Bonjour, ici la Clinique familiale Riverside. Comment puis-je vous aider aujourd\u2019hui?", 1]], [['Appelant', "C\u2019est Jordan. J\u2019ai mal aux dents depuis des jours."], ['AI Phone', 'D\u00e9sol\u00e9 de l\u2019apprendre, Jordan. \u00cates-vous d\u00e9j\u00e0 venu nous voir?', 1]], [['Appelant', "Je m\u2019inqui\u00e8te un peu du co\u00fbt."], ['AI Phone', "La plupart des examens sont couverts, Jordan. Je peux v\u00e9rifier votre assurance tout de suite.", 1]], [['Appelant', 'Avez-vous quelque chose demain?'], ['AI Phone', "10 h 30 fonctionne. C\u2019est r\u00e9serv\u00e9, Jordan.", 1]], [['Appelant', 'Puis-je payer le d\u00e9p\u00f4t maintenant?'], ['AI Phone', 'J\u2019envoie un lien de paiement s\u00e9curis\u00e9 \u00e0 votre t\u00e9l\u00e9phone maintenant.', 1]], [['AI Phone', "Vous recevrez un texto de confirmation et un rappel la veille, Jordan.", 1]]]], ['Collecteur d\u2019avis en ligne', 'Obtenez des avis, grimpez dans les r\u00e9sultats', G.star, 'Demande d\u2019avis', [[G.star, 'Collecte les avis automatiquement'], [G.search, 'Fait grimper votre profil d\u2019entreprise Google'], [G.chat, 'R\u00e9pond \u00e0 chaque avis'], [G.spark, 'Vous fait trouver sur les plateformes d\u2019IA'], [G.funnel, 'Transforme la r\u00e9putation en revenus'], [G.users, 'Transforme les avis en recommandations']], [[['SMS IA', 'Bonjour Maria, merci d\u2019avoir choisi Riverside aujourd\u2019hui! Pourriez-vous laisser un petit avis?', 1]], [['Customer', "Bien s\u00fbr, je le publie maintenant!"]], [['SMS IA', 'Merci, Maria! Nous sommes ravis d\u2019avoir pu vous aider.', 1]], [['SMS IA', 'Riverside appara\u00eet maintenant sur Google et ChatGPT parmi les mieux not\u00e9s.', 1]], [['SMS IA', 'Cet avis 5 \u00e9toiles vient d\u2019amener une nouvelle r\u00e9servation.', 1]], [['SMS IA', "Connaissez-vous quelqu\u2019un qui nous adorerait aussi, Maria? Partagez votre lien et nous vous remercierons.", 1]]]], ['Active AI Orbit', 'Votre site Web vocal', G.globe, 'Visiteur sur le site', [[G.mic, 'Exp\u00e9rience de site Web vocale'], [G.chat, 'R\u00e9pond instantan\u00e9ment aux questions'], [G.funnel, 'Qualifie et capte les leads'], [G.cal, 'Prend les rendez-vous automatiquement'], [G.infin, 'Fonctionne sur tous les appareils'], [G.users, 'Transf\u00e8re \u00e0 une vraie personne au besoin']], [[['Visiteur', 'Puis-je simplement parler au lieu d\u2019\u00e9crire?'], ['Orbit', "Bien s\u00fbr. Allez-y, je vous \u00e9coute.", 1]], [['Visiteur', 'Prenez-vous des clients sans rendez-vous aujourd\u2019hui?'], ['Orbit', "Oui, jusqu\u2019\u00e0 18 h. Passez nous voir.", 1]], [['Visiteur', 'J\u2019ai besoin d\u2019une soumission pour la refonte d\u2019un site Web.'], ['Orbit', "Compris. Puis-je avoir votre nom et votre num\u00e9ro, Alex?", 1]], [['Orbit', "C\u2019est tout bon, Alex. Jeudi \u00e0 14 h.", 1]], [['Visiteur', "Je suis sur mon t\u00e9l\u00e9phone en ce moment."], ['Orbit', '\u00c7a fonctionne exactement pareil ici, Alex.', 1]], [['Visiteur', 'Puis-je parler \u00e0 une vraie personne?'], ['Orbit', "Bien s\u00fbr. Je vous mets en contact avec notre \u00e9quipe, Alex.", 1]]]]].map(function (_ref18, ci) {
    var _ref19 = _slicedToArray(_ref18, 6),
      head = _ref19[0],
      sub = _ref19[1],
      badge = _ref19[2],
      live = _ref19[3],
      items = _ref19[4],
      demo = _ref19[5];
    return React.createElement("div", {
      key: head,
      className: "hf-card",
      style: {
        '--ci': ci,
        display: 'flex',
        flexDirection: 'column',
        gap: 5,
        minWidth: 0,
        background: '#171717',
        borderRadius: 14,
        padding: '9px 14px 10px',
        boxShadow: '0 10px 26px rgba(92,36,4,.18)'
      }
    }, React.createElement("div", {
      className: "hf-head",
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 9,
        paddingBottom: 5,
        borderBottom: '1px solid rgba(255,250,245,.14)'
      }
    }, React.createElement("span", {
      style: {
        flex: '0 0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 26,
        height: 26,
        borderRadius: '50%',
        background: 'var(--wb-orange)'
      }
    }, React.createElement(Glyph, {
      d: badge,
      size: 14
    })), React.createElement("span", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        minWidth: 0
      }
    }, React.createElement("span", {
      style: {
        fontSize: 12,
        fontWeight: 800,
        letterSpacing: '.12em',
        textTransform: 'uppercase',
        color: '#FFFFFF'
      }
    }, head), React.createElement("span", {
      style: {
        fontSize: 11,
        fontWeight: 800,
        letterSpacing: '.08em',
        textTransform: 'uppercase',
        color: 'var(--wb-orange)'
      }
    }, sub))), React.createElement(HfDemo, {
      items: items,
      demo: demo,
      live: live
    }));
  })), React.createElement("div", {
    className: has3d ? 'wb-hero-dark' : 'wb-hero-plain',
    style: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, React.createElement(HeroPath, null), has3d && React.createElement("div", {
    className: "wb-hero-orbit",
    style: {
      width: '100%',
      maxWidth: 1120,
      display: 'flex',
      marginTop: 6,
      height: 'clamp(300px,44vh,460px)'
    }
  }, React.createElement(Orbit3DStage, {
    listening: state === 'listening',
    onTap: talk
  }))), React.createElement("div", {
    className: "wb-hero-rate",
    style: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: 2
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 10
    }
  }, React.createElement("span", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 7
    }
  }, React.createElement("span", {
    "aria-hidden": "true",
    style: {
      display: 'flex',
      gap: 1.5,
      color: 'var(--wb-gold)',
      fontSize: 13,
      letterSpacing: '.04em'
    }
  }, "\u2605\u2605\u2605\u2605\u2605"), React.createElement("span", {
    style: {
      fontSize: 13,
      fontWeight: 700,
      color: 'var(--wb-white)'
    }
  }, "4,9/5"), React.createElement("span", {
    style: {
      fontSize: 13,
      fontWeight: 600,
      color: 'var(--wb-white)'
    }
  }, "\u00c9valu\u00e9 par des entreprises comme la v\u00f4tre!")))), React.createElement(Card, {
    surface: "cream",
    radius: "xl",
    padding: "none",
    elevation: "none",
    frame: false,
    style: {
      width: '100%',
      maxWidth: 1120,
      padding: 7,
      marginTop: 4,
      boxShadow: 'var(--shadow-lg)',
      flex: '1 1 auto',
      minHeight: 0,
      display: 'flex'
    }
  }, "        ", React.createElement(Card, {
    surface: "white",
    radius: "lg",
    padding: "none",
    elevation: "none",
    frame: false,
    style: {
      padding: '6px 18px',
      display: 'grid',
      gridTemplateColumns: has3d ? 'minmax(0,1fr) minmax(400px,470px)' : 'minmax(0,0.78fr) minmax(400px,470px)',
      gridTemplateRows: 'minmax(0,1fr)',
      gap: has3d ? '0 26px' : '0 18px',
      alignItems: 'stretch',
      flex: '1 1 auto',
      minHeight: 0,
      width: '100%'
    }
  }, React.createElement("div", {
    style: has3d ? {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 0,
      minHeight: 0
    } : {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 0,
      minHeight: 0,
      paddingRight: 18,
      borderRight: '1px solid var(--border-hairline)'
    }
  }, React.createElement("div", {
    ref: stageRef,
    style: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flex: '1 1 auto',
      minHeight: 0
    }
  }, has3d ? React.createElement("div", {
    className: "hero-feats",
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3,minmax(0,1fr))',
      gap: 12,
      width: '100%',
      maxWidth: 1120,
      textAlign: 'left'
    }
  }, [['\u00c0 chaque appel', 'Du bonjour \u00e0 la conclusion', G.phone, 'R\u00e9servation', [[G.bolt, 'R\u00e9pond instantan\u00e9ment'], [G.users, 'Qualifie les leads'], [G.chat, 'G\u00e8re les objections'], [G.cal, 'Prend les rendez-vous'], [G.card, 'Capture les paiements'], [G.send, 'Envoie des textos pendant l\u2019appel et pour le suivi']], [[['Appelant', 'Hi!'], ['AI Phone', "Bonjour, ici la Clinique familiale Riverside. Comment puis-je vous aider aujourd\u2019hui?", 1]], [['Appelant', "C\u2019est Jordan. J\u2019ai mal aux dents depuis des jours."], ['AI Phone', 'D\u00e9sol\u00e9 de l\u2019apprendre, Jordan. \u00cates-vous d\u00e9j\u00e0 venu nous voir?', 1]], [['Appelant', "Je m\u2019inqui\u00e8te un peu du co\u00fbt."], ['AI Phone', "La plupart des examens sont couverts, Jordan. Je peux v\u00e9rifier votre assurance tout de suite.", 1]], [['Appelant', 'Avez-vous quelque chose demain?'], ['AI Phone', "10 h 30 fonctionne. C\u2019est r\u00e9serv\u00e9, Jordan.", 1]], [['Appelant', 'Puis-je payer le d\u00e9p\u00f4t maintenant?'], ['AI Phone', 'J\u2019envoie un lien de paiement s\u00e9curis\u00e9 \u00e0 votre t\u00e9l\u00e9phone maintenant.', 1]], [['AI Phone', "Vous recevrez un texto de confirmation et un rappel la veille, Jordan.", 1]]]], ['Collecteur d\u2019avis en ligne', 'Obtenez des avis, grimpez dans les r\u00e9sultats', G.star, 'Demande d\u2019avis', [[G.star, 'Collecte les avis automatiquement'], [G.search, 'Fait grimper votre profil d\u2019entreprise Google'], [G.chat, 'R\u00e9pond \u00e0 chaque avis'], [G.spark, 'Vous fait trouver sur les plateformes d\u2019IA'], [G.funnel, 'Transforme la r\u00e9putation en revenus'], [G.users, 'Transforme les avis en recommandations']], [[['SMS IA', 'Bonjour Maria, merci d\u2019avoir choisi Riverside aujourd\u2019hui! Pourriez-vous laisser un petit avis?', 1]], [['Customer', "Bien s\u00fbr, je le publie maintenant!"]], [['SMS IA', 'Merci, Maria! Nous sommes ravis d\u2019avoir pu vous aider.', 1]], [['SMS IA', 'Riverside appara\u00eet maintenant sur Google et ChatGPT parmi les mieux not\u00e9s.', 1]], [['SMS IA', 'Cet avis 5 \u00e9toiles vient d\u2019amener une nouvelle r\u00e9servation.', 1]], [['SMS IA', "Connaissez-vous quelqu\u2019un qui nous adorerait aussi, Maria? Partagez votre lien et nous vous remercierons.", 1]]]], ['Active AI Orbit', 'Votre site Web vocal', G.globe, 'Visiteur sur le site', [[G.mic, 'Exp\u00e9rience de site Web vocale'], [G.chat, 'R\u00e9pond instantan\u00e9ment aux questions'], [G.funnel, 'Qualifie et capte les leads'], [G.cal, 'Prend les rendez-vous automatiquement'], [G.infin, 'Fonctionne sur tous les appareils'], [G.users, 'Transf\u00e8re \u00e0 une vraie personne au besoin']], [[['Visiteur', 'Puis-je simplement parler au lieu d\u2019\u00e9crire?'], ['Orbit', "Bien s\u00fbr. Allez-y, je vous \u00e9coute.", 1]], [['Visiteur', 'Prenez-vous des clients sans rendez-vous aujourd\u2019hui?'], ['Orbit', "Oui, jusqu\u2019\u00e0 18 h. Passez nous voir.", 1]], [['Visiteur', 'J\u2019ai besoin d\u2019une soumission pour la refonte d\u2019un site Web.'], ['Orbit', "Compris. Puis-je avoir votre nom et votre num\u00e9ro, Alex?", 1]], [['Orbit', "C\u2019est tout bon, Alex. Jeudi \u00e0 14 h.", 1]], [['Visiteur', "Je suis sur mon t\u00e9l\u00e9phone en ce moment."], ['Orbit', '\u00c7a fonctionne exactement pareil ici, Alex.', 1]], [['Visiteur', 'Puis-je parler \u00e0 une vraie personne?'], ['Orbit', "Bien s\u00fbr. Je vous mets en contact avec notre \u00e9quipe, Alex.", 1]]]]].map(function (_ref20, ci) {
    var _ref21 = _slicedToArray(_ref20, 6),
      head = _ref21[0],
      sub = _ref21[1],
      badge = _ref21[2],
      live = _ref21[3],
      items = _ref21[4],
      demo = _ref21[5];
    return React.createElement("div", {
      key: head,
      className: "hf-card",
      style: {
        '--ci': ci,
        display: 'flex',
        flexDirection: 'column',
        gap: 5,
        minWidth: 0,
        background: '#171717',
        borderRadius: 14,
        padding: '9px 14px 10px',
        boxShadow: '0 10px 26px rgba(92,36,4,.18)'
      }
    }, React.createElement("div", {
      className: "hf-head",
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 9,
        paddingBottom: 5,
        borderBottom: '1px solid rgba(255,250,245,.14)'
      }
    }, React.createElement("span", {
      style: {
        flex: '0 0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 26,
        height: 26,
        borderRadius: '50%',
        background: 'var(--wb-orange)'
      }
    }, React.createElement(Glyph, {
      d: badge,
      size: 14
    })), React.createElement("span", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        minWidth: 0
      }
    }, React.createElement("span", {
      style: {
        fontSize: 12,
        fontWeight: 800,
        letterSpacing: '.12em',
        textTransform: 'uppercase',
        color: '#FFFFFF'
      }
    }, head), React.createElement("span", {
      style: {
        fontSize: 11,
        fontWeight: 800,
        letterSpacing: '.08em',
        textTransform: 'uppercase',
        color: 'var(--wb-orange)'
      }
    }, sub))), React.createElement(HfDemo, {
      items: items,
      demo: demo,
      live: live
    }));
  })) : React.createElement(React.Fragment, null, burst && fwReach > 34 && React.createElement(Firework, {
    dir: -1,
    x: fwX,
    reach: fwReach
  }), stage.w > 0 && React.createElement(Orbit, {
    size: orbSize,
    detail: true,
    assemble: true,
    lift: true,
    onAssembled: onAssembled,
    state: state,
    basePath: A,
    onClick: talk,
    style: {
      maxWidth: '100%',
      maxHeight: '100%'
    }
  }), burst && fwReach > 34 && React.createElement(Firework, {
    dir: 1,
    x: fwX,
    reach: fwReach
  }))), !has3d && state !== 'listening' && React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 7,
      marginTop: 6
    }
  }, React.createElement("span", {
    style: {
      fontSize: 12,
      fontWeight: 800,
      letterSpacing: '.1em',
      textTransform: 'uppercase',
      color: 'var(--orange-700)'
    }
  }, "TOUCHEZ L\u2019AI PHONE POUR PARLER")), React.createElement("div", {
    style: {
      display: has3d ? 'none' : 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 12,
      width: '100%',
      marginTop: 18
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 7
    }
  }, React.createElement("svg", {
    width: "15",
    height: "22",
    viewBox: "0 0 16 24",
    fill: "var(--wb-orange)",
    "aria-hidden": "true"
  }, React.createElement("circle", {
    cx: "7.6",
    cy: "7",
    r: "3.5"
  }), React.createElement("path", {
    d: "M1.9 21.4c0-3.4 2.6-6 5.7-6s5.7 2.6 5.7 6z"
  })), React.createElement(SoundRibbon, {
    height: 22,
    active: state === 'listening',
    tone: "light"
  }), React.createElement("span", {
    style: {
      display: 'inline-flex',
      width: 24,
      height: 24,
      flex: 'none'
    },
    "aria-hidden": "true"
  }, React.createElement(Orbit, {
    size: 24,
    state: state === 'listening' ? 'listening' : 'breathing',
    basePath: A
  })))), React.createElement("span", {
    style: {
      fontSize: 14,
      fontWeight: 700,
      textAlign: 'center',
      marginTop: 10,
      display: has3d ? 'none' : undefined
    }
  }, state === 'listening' ? 'Listening…' : 'Essayez notre AI Phone\u00a0: parlez \u00e0 notre r\u00e9ceptionniste IA.')), React.createElement("form", {
    onSubmit: submit,
    style: {
      display: 'grid',
      gap: 8,
      width: '100%',
      alignContent: 'center'
    }
  }, React.createElement("div", {
    className: "wb-hf-head",
    style: {
      display: 'grid',
      gap: 3
    }
  }, React.createElement("h2", {
    className: "wb-hf-title",
    style: {
      margin: 0,
      fontSize: 'clamp(20px,1.55vw,24px)',
      lineHeight: 1.15,
      fontWeight: 800,
      letterSpacing: '-.01em',
      color: 'var(--text-primary)'
    }
  }, "Ne manquez plus jamais un lead."), React.createElement("div", {
    className: "mono",
    style: {
      letterSpacing: '.14em',
      textTransform: 'uppercase'
    }
  }, "Chaque minute d\u2019attente, c\u2019est une autre occasion perdue")), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2,minmax(0,1fr))',
      gap: 8
    }
  }, React.createElement(Field, {
    label: "Nom complet",
    placeholder: "Sarah Mitchell",
    value: form.name,
    onChange: set('name'),
    name: "name",
    autoComplete: "name"
  }), React.createElement(Field, {
    label: "Nom de l\u2019entreprise",
    placeholder: "Clinique familiale Riverside",
    value: form.business,
    onChange: set('business'),
    name: "company",
    autoComplete: "organization"
  }), React.createElement(Field, _defineProperty(_defineProperty(_defineProperty({
    label: "Num\u00e9ro de t\u00e9l\u00e9phone",
    type: "tel",
    name: "phone",
    autoComplete: "tel",
    required: true,
    placeholder: "(514) 555-0134",
    value: form.phone,
    onChange: set('phone')
  }, "name", "phone"), "autoComplete", "tel"), "inputMode", "tel")), React.createElement(Field, _defineProperty(_defineProperty(_defineProperty({
    label: "Meilleur courriel",
    type: "email",
    name: "email",
    autoComplete: "email",
    required: true,
    placeholder: "sarah@riversideclinic.com",
    value: form.email,
    onChange: set('email')
  }, "name", "email"), "autoComplete", "email"), "inputMode", "email"))), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr)',
      gap: 8,
      alignItems: 'end'
    }
  }, React.createElement("div", {
    style: {
      display: 'grid',
      gap: 6,
      position: 'relative'
    }
  }, React.createElement("label", {
    style: {
      fontSize: 13,
      fontWeight: 700,
      color: 'var(--text-primary)'
    }
  }, "Qu\u2019est-ce qui vous int\u00e9resse?"), React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setOpen(!open);
    },
    "aria-expanded": open,
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 10,
      width: '100%',
      padding: '12px 14px',
      fontFamily: 'var(--font-core)',
      fontSize: 15,
      fontWeight: 600,
      textAlign: 'left',
      color: 'var(--text-primary)',
      background: picks.length ? 'var(--wb-white)' : 'rgba(252,99,6,.06)',
      border: '2px solid ' + (open || !picks.length ? 'var(--wb-orange)' : 'var(--border-strong)'),
      borderRadius: 'var(--radius-md)',
      cursor: 'pointer'
    }
  }, React.createElement("span", {
    style: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  }, picks.length ? picks.join(', ') : 'Choisissez-en un ou plusieurs'), React.createElement("span", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flex: '0 0 auto',
      width: 22,
      height: 22,
      borderRadius: '50%',
      background: 'var(--wb-orange)',
      color: 'var(--wb-white)',
      fontSize: 15,
      lineHeight: 1,
      fontWeight: 800,
      transform: open ? 'rotate(180deg)' : 'none',
      transition: 'transform var(--dur-fast) var(--ease-standard)'
    }
  }, "\u25BE")), open && React.createElement("div", {
    style: {
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      zIndex: 20,
      marginTop: 6,
      padding: 6,
      display: 'grid',
      gap: 2,
      background: 'var(--wb-white)',
      border: '1px solid var(--border-hairline)',
      borderRadius: 'var(--radius-md)',
      boxShadow: 'var(--shadow-lg)'
    }
  }, PRODUCTS.map(function (p) {
    var on = picks.includes(p);
    return React.createElement("label", {
      key: p,
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '9px 10px',
        borderRadius: 'var(--radius-sm)',
        fontSize: 14,
        fontWeight: 600,
        cursor: 'pointer',
        background: on ? 'rgba(252,99,6,.08)' : 'transparent'
      }
    }, React.createElement("input", {
      type: "checkbox",
      checked: on,
      onChange: function onChange() {
        return toggle(p);
      },
      style: {
        width: 16,
        height: 16,
        accentColor: 'var(--wb-orange)',
        cursor: 'pointer'
      }
    }), React.createElement("span", null, p));
  }))), React.createElement(Button, {
    variant: "primary",
    full: true,
    arrow: true,
    type: "submit",
    disabled: status === 'sending'
  }, status === 'sending' ? 'Sending…' : status === 'sent' ? 'C\u2019est not\u00e9, nous vous appellerons' : 'Obtenez vos AI Phones et faites cro\u00eetre vos revenus d\u00e8s maintenant')), status === 'sent' && React.createElement("p", {
    role: "status",
    style: {
      margin: 0,
      fontSize: 13,
      fontWeight: 700,
      color: 'var(--green-500)'
    }
  }, "Merci, un conseiller AI Phone vous appellera sous peu."), status === 'error' && React.createElement("p", {
    role: "alert",
    style: {
      margin: 0,
      fontSize: 13,
      fontWeight: 700,
      color: 'var(--red-500)'
    }
  }, "L\u2019envoi a \u00e9chou\u00e9. Veuillez r\u00e9essayer ou nous appeler directement.")))), React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px 22px',
      marginTop: 2
    }
  }, React.createElement(CheckItem, {
    inverse: true
  }, "Conversations naturelles"), React.createElement(CheckItem, {
    inverse: true
  }, "Disponible 24/7"), React.createElement(CheckItem, {
    inverse: true
  }, "Transformez chaque appel en r\u00e9servation"), React.createElement(CheckItem, {
    inverse: true
  }, "Joignez vos leads en quelques secondes"))));
}
var PROOF_ROWS = [[['Lenovo', 1.06, 'lenovo.com'], ['Anker', 1, 'anker.com'], ['Everise', 1, 'weareeverise.com'], ['Asbury Automotive Group', .82, 'asburyauto.com'], ['Varsity Tutors', .9, 'varsitytutors.com'], ['GiftHealth', .94, 'gifthealth.com'], ['SWTCH', 1.02, 'swtchenergy.com'], ['Matic', 1.04, 'matic.com'], ['Ro', 1.18, 'ro.co']], [['TripleTen', .98, 'tripleten.com'], ['Cents', 1.06, 'trycents.com'], ['Pine Park Health', .86, 'pineparkhealth.com'], ['SpareLabs', .96, 'sparelabs.com'], ['Sunshine Loans', .88, 'sunshineloans.com.au'], ['Boatzon', 1, 'boatzon.com'], ['Inbounds.com', .92, 'inbounds.com'], ['iSpeedToLead', .9, 'ispeedtolead.com'], ['Mercor', 1.04, 'mercor.com']], [['Medical Data Systems', .82, 'medicaldatasystems.com'], ['BrightChamps', .92, 'brightchamps.com'], ['AccioJob', .98, 'acciojob.com'], ['Doxy.me', 1.04, 'doxy.me'], ['Respaid', 1.02, 'respaid.com'], ['StorageVault', .9, 'storagevaultcanada.com'], ['SmartEnergy.com', .86, 'smartenergy.com'], ['Luna Physical Therapy', .82, 'getluna.com']]];
var SLUG = function SLUG(n) {
  return n.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
};
function ProofLogo(_ref22) {
  var name = _ref22.name,
    w = _ref22.w,
    domain = _ref22.domain;
  var _React$useState25 = React.useState(null),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    src = _React$useState26[0],
    setSrc = _React$useState26[1];
  React.useEffect(function () {
    var LOCAL_LOGOS = {
      "caller-id": "png",
      "google-business": "png",
      "google-calendar": "png",
      "hubspot": "png",
      "jobber": "png",
      "n8n": "png",
      "slack": "png",
      "stripe": "png",
      "twilio-sms": "png",
      "twilio": "png"
    };
    var srcs = LOCAL_LOGOS[SLUG(name)] ? [LOGOS + SLUG(name) + '.' + LOCAL_LOGOS[SLUG(name)]] : [];
    var dead = false,
      i = 0;
    var _tryNext = function tryNext() {
      if (dead || i >= srcs.length) return;
      var url = srcs[i++];
      var img = new Image();
      img.onload = function () {
        if (!dead) setSrc(url);
      };
      img.onerror = _tryNext;
      img.src = url;
    };
    _tryNext();
    return function () {
      dead = true;
    };
  }, [name, domain]);
  if (!src) return React.createElement("span", {
    className: "wb-proof-logo",
    style: {
      fontFamily: 'var(--font-core)',
      fontSize: 'calc(clamp(20px,1.55vw,27px) * ' + w + ')',
      fontWeight: 800,
      letterSpacing: '-.02em',
      whiteSpace: 'nowrap',
      color: 'var(--ink-700)',
      opacity: .62,
      transition: 'opacity var(--dur-base) var(--ease-standard),color var(--dur-base) var(--ease-standard)'
    }
  }, name);
  return React.createElement("img", {
    className: "wb-proof-logo",
    src: src,
    alt: name,
    style: {
      height: 'calc(clamp(26px,2.1vw,38px) * ' + w + ')',
      width: 'auto',
      maxWidth: 200,
      objectFit: 'contain',
      flex: 'none',
      filter: 'grayscale(1) contrast(.92)',
      opacity: .66,
      transition: 'opacity var(--dur-base) var(--ease-standard),filter var(--dur-base) var(--ease-standard)'
    }
  });
}
function ProofRow(_ref23) {
  var row = _ref23.row,
    anim = _ref23.anim,
    dur = _ref23.dur;
  var items = [].concat(_toConsumableArray(row), _toConsumableArray(row), _toConsumableArray(row), _toConsumableArray(row));
  return React.createElement("div", {
    className: "wb-proof-vp",
    style: {
      overflow: 'hidden',
      width: '100%',
      minWidth: 0,
      maskImage: 'linear-gradient(90deg,transparent 0,#000 12%,#000 88%,transparent 100%)',
      WebkitMaskImage: 'linear-gradient(90deg,transparent 0,#000 12%,#000 88%,transparent 100%)'
    }
  }, React.createElement("div", {
    className: "wb-proof-track",
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 'clamp(38px,5vw,78px)',
      width: 'max-content',
      '--wb-proof-dur': dur + 's',
      animationName: anim,
      animationDuration: dur + 's',
      animationTimingFunction: 'linear',
      animationIterationCount: 'infinite'
    }
  }, items.map(function (_ref24, i) {
    var _ref25 = _slicedToArray(_ref24, 3),
      n = _ref25[0],
      w = _ref25[1],
      d = _ref25[2];
    return React.createElement(ProofLogo, {
      key: n + i,
      name: n,
      w: w,
      domain: d
    });
  })));
}
function ProofStrip() {
  return React.createElement("section", {
    id: "social-proof",
    style: {
      background: 'var(--wb-cream)',
      borderTop: '1px solid var(--border-hairline)',
      borderBottom: '1px solid var(--border-hairline)',
      padding: 'clamp(34px,3.6vw,54px) 0',
      overflow: 'hidden'
    }
  }, React.createElement("style", null, "\n@keyframes wbProofL{from{transform:translateX(-25%)}to{transform:translateX(0)}}\n@keyframes wbProofR{from{transform:translateX(0)}to{transform:translateX(-25%)}}\n.wb-proof-logo:hover{opacity:1;color:var(--ink-900);filter:none}\n#social-proof .wb-proof-vp:hover .wb-proof-track{animation-duration:calc(var(--wb-proof-dur) * 1.75)}\n@media(max-width:820px){#social-proof .wb-proof-row-3{display:none}}\n@media(prefers-reduced-motion:reduce){\n  #social-proof .wb-proof-track{animation:none!important;width:auto!important;flex-wrap:wrap;justify-content:center;row-gap:26px}\n  #social-proof .wb-proof-vp{mask-image:none!important;-webkit-mask-image:none!important}\n  #social-proof .wb-proof-logo:nth-child(n+10){display:none}\n}"), React.createElement("div", {
    className: "wrap",
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 10,
      marginBottom: 'clamp(22px,2.2vw,32px)'
    }
  }, React.createElement("span", {
    className: "mono",
    style: {
      letterSpacing: '.16em',
      textTransform: 'uppercase',
      color: 'var(--wb-orange)',
      fontSize: 13,
      fontWeight: 800
    }
  }, "D\u00e9ploy\u00e9 \u00e0 grande \u00e9chelle"), React.createElement("h2", {
    style: {
      fontSize: 'clamp(22px,2.5vw,40px)',
      lineHeight: 1.12,
      letterSpacing: '-.02em',
      textAlign: 'center',
      color: 'var(--wb-charcoal)',
      whiteSpace: 'nowrap'
    }
  }, "Notre syst\u00e8me AI Phone r\u00e9pond aux appels de\u00a0:")), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr)',
      gap: 'clamp(22px,2.4vw,34px)'
    }
  }, React.createElement("div", {
    className: "wb-proof-row-1",
    style: {
      minWidth: 0
    }
  }, React.createElement(ProofRow, {
    row: PROOF_ROWS[0],
    anim: "wbProofL",
    dur: 82
  })), React.createElement("div", {
    className: "wb-proof-row-2",
    style: {
      minWidth: 0
    }
  }, React.createElement(ProofRow, {
    row: PROOF_ROWS[1],
    anim: "wbProofR",
    dur: 97
  })), React.createElement("div", {
    className: "wb-proof-row-3",
    style: {
      minWidth: 0
    }
  }, React.createElement(ProofRow, {
    row: PROOF_ROWS[2],
    anim: "wbProofL",
    dur: 89
  }))));
}
var IMS_STEPS = [['magnet', 'Marketing', 'Cr\u00e9e l\u2019attention', 'Vous les attirez.'], ['orb', 'WinBoost AI Phone', 'Capte l\u2019attention', 'En quelques secondes.'], ['chat-bubble', 'Conversation', 'Cr\u00e9e l\u2019engagement', 'L\u2019IA s\u2019en occupe instantan\u00e9ment.'], ['calendar', 'R\u00e9servation / Capture du paiement', 'Cr\u00e9e des affaires', 'Plus de contrats. Plus de revenus.']];
var IMS_DETAIL = [{
  q: '1. Marketing\u00a0: vous cr\u00e9ez l\u2019attention',
  a: 'Vos publicit\u00e9s, votre r\u00e9f\u00e9rencement (SEO), votre profil d\u2019entreprise Google, vos recommandations et vos publications sur les r\u00e9seaux sociaux font leur travail\u00a0: quelqu\u2019un voit votre entreprise et d\u00e9cide de vous joindre. \u00c0 ce moment-l\u00e0, vous avez d\u00e9j\u00e0 pay\u00e9 pour cette attention. Ce qui se passe dans les prochaines secondes d\u00e9termine si elle se transforme en revenus ou si elle va \u00e0 un concurrent.'
}, {
  q: '2. WinBoost AI Phone\u00a0: il capte l\u2019attention en quelques secondes',
  a: 'D\u00e8s que le lead appelle, envoie un texto ou parle \u00e0 votre site Web par Active AI Orbit, votre WinBoost AI Phone r\u00e9pond d\u00e8s la premi\u00e8re sonnerie, 24/7, y compris la nuit, les fins de semaine, les jours f\u00e9ri\u00e9s et aux heures de pointe o\u00f9 jusqu\u2019\u00e0 20 appels arrivent en m\u00eame temps. Pas de bo\u00eete vocale, pas de musique d\u2019attente, pas de liste de rappels pour demain.'
}, {
  q: '3. Conversation\u00a0: il cr\u00e9e l\u2019engagement instantan\u00e9ment',
  a: "Votre AI Phone tient une conversation naturelle, comme un humain, dans la langue de l\u2019appelant. Il r\u00e9pond aux questions sur vos services, vos tarifs et votre territoire desservi, pose les questions de qualification que vous poseriez et g\u00e8re les objections avec votre positionnement approuv\u00e9, pendant que l\u2019intention de l\u2019appelant est encore \u00e9lev\u00e9e."
}, {
  q: '4. R\u00e9servation ou paiement\u00a0: il cr\u00e9e des affaires',
  a: 'La conversation se termine par un r\u00e9sultat\u00a0: un rendez-vous inscrit dans votre calendrier, un d\u00e9p\u00f4t ou un paiement captur\u00e9, ou un transfert en direct vers votre \u00e9quipe. Les confirmations et les rappels par texto partent automatiquement, et chaque appel est consign\u00e9 avec sa transcription dans votre portail client.'
}];
function InMarketingSystem() {
  return React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 'clamp(22px,2.4vw,34px)'
    }
  }, React.createElement("div", {
    style: {
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: 8
    }
  }, React.createElement("h2", {
    className: "h2",
    style: {
      margin: '0 auto',
      textAlign: 'center'
    }
  }, "Le syst\u00e8me InMarketing"), React.createElement("p", {
    style: {
      fontSize: 'var(--fs-body)',
      color: 'var(--text-secondary)'
    }
  }, "De l\u2019int\u00e9r\u00eat \u00e0 l\u2019occasion d\u2019affaires. En quelques secondes.")), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr auto 1fr auto 1fr auto 1fr',
      alignItems: 'stretch',
      gap: 'clamp(10px,1.2vw,18px)'
    }
  }, IMS_STEPS.map(function (_ref26, i) {
    var _ref27 = _slicedToArray(_ref26, 4),
      ic = _ref27[0],
      title = _ref27[1],
      role = _ref27[2],
      note = _ref27[3];
    return React.createElement(React.Fragment, {
      key: title
    }, React.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: 12,
        padding: 'clamp(20px,2vw,28px) clamp(14px,1.4vw,22px)',
        borderRadius: 'var(--radius-lg)',
        background: i === 1 ? 'rgba(252,99,6,.06)' : 'var(--surface-card)',
        border: '1px solid ' + (i === 1 ? 'var(--wb-orange)' : 'var(--border-card)'),
        boxShadow: i === 1 ? '0 14px 34px rgba(252,99,6,.14)' : 'none',
        animationDelay: (i * 0.19).toFixed(2) + 's'
      },
      className: "wb-in-up"
    }, React.createElement("div", {
      style: {
        height: 52,
        display: 'flex',
        alignItems: 'center'
      }
    }, ic === 'orb' ? React.createElement(Orbit, {
      size: 48,
      state: "listening",
      detail: true,
      basePath: A
    }) : React.createElement(Icon, {
      name: ic,
      size: 44,
      basePath: ICONS
    })), React.createElement("div", {
      style: {
        minHeight: '2.5em',
        display: 'flex',
        alignItems: 'center',
        fontSize: 14,
        fontWeight: 800,
        letterSpacing: '.06em',
        textTransform: 'uppercase',
        lineHeight: 1.25,
        textAlign: 'center'
      }
    }, title), React.createElement("div", {
      style: {
        fontSize: 15,
        fontWeight: 700,
        color: i === 1 ? 'var(--wb-orange)' : 'var(--text-primary)'
      }
    }, role), React.createElement("div", {
      style: {
        fontSize: 14,
        color: 'var(--text-secondary)'
      }
    }, note)), i < 3 && React.createElement("div", {
      "aria-hidden": "true",
      className: "wb-in-up",
      style: {
        display: 'flex',
        alignItems: 'center',
        color: 'var(--wb-orange)',
        fontSize: 22,
        fontWeight: 700,
        animationDelay: (i * 0.19 + 0.1).toFixed(2) + 's'
      }
    }, "\u2192"));
  })), React.createElement("div", {
    style: {
      maxWidth: 880,
      width: '100%',
      margin: '0 auto'
    }
  }, React.createElement(Accordion, {
    items: IMS_DETAIL
  })));
}
function InMarketingCopy() {
  return React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 'clamp(20px,2vw,30px)'
    }
  }, React.createElement("h2", {
    className: "h2",
    style: {
      margin: '0 auto',
      maxWidth: 'none',
      fontSize: 'min(2.1vw,32px)',
      whiteSpace: 'nowrap',
      textAlign: 'center'
    }
  }, "Le meilleur syst\u00e8me InMarketing int\u00e8gre la toute derni\u00e8re technologie innovante de WinBoost AI."), React.createElement(Card, {
    surface: "cream",
    padding: "none",
    radius: "xl",
    style: {
      position: 'relative',
      overflow: 'hidden'
    }
  }, React.createElement("div", {
    "aria-hidden": "true",
    style: {
      position: 'absolute',
      right: '-90px',
      top: '-90px',
      width: 280,
      height: 280,
      borderRadius: '50%',
      background: 'radial-gradient(circle,rgba(252,99,6,.13),rgba(252,99,6,0) 70%)',
      pointerEvents: 'none'
    }
  }), React.createElement("div", {
    style: {
      position: 'relative',
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1.75fr) minmax(280px,1fr)',
      alignItems: 'stretch'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 18,
      padding: 'clamp(30px,3.2vw,48px)'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 12
    }
  }, React.createElement(Orbit, {
    size: 34,
    state: "listening",
    basePath: A
  }), React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--wb-orange)'
    }
  }, "Technologie innovante")), React.createElement("p", {
    style: {
      fontSize: 'clamp(18px,1.55vw,23px)',
      lineHeight: 1.5,
      fontWeight: 700,
      color: 'var(--text-primary)'
    }
  }, "Nous avons cr\u00e9\u00e9 les meilleurs AI Phones pour engager vos clients par la voix ou par texto en quelques secondes apr\u00e8s qu\u2019ils ont manifest\u00e9 leur int\u00e9r\u00eat. C\u2019est la ", React.createElement("span", {
    style: {
      color: 'var(--wb-orange)'
    }
  }, "technologie innovante de WinBoost AI"), "."), React.createElement("div", {
    style: {
      display: 'flex',
      gap: 16,
      alignItems: 'stretch'
    }
  }, React.createElement("p", {
    style: {
      fontSize: 'var(--fs-body)',
      lineHeight: 'var(--lh-body)',
      color: 'var(--text-primary)',
      margin: 0
    }
  }, React.createElement("span", {
    style: {
      background: 'rgba(252,99,6,.24)',
      padding: '.1em .18em',
      borderRadius: 3,
      boxDecorationBreak: 'clone',
      WebkitBoxDecorationBreak: 'clone'
    }
  }, "L\u2019attention est la monnaie la mieux pay\u00e9e de notre soci\u00e9t\u00e9 moderne, et l\u2019attention entre votre entreprise et vos leads est enfin parfaite.")))), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 0,
      padding: 'clamp(30px,3.2vw,48px)',
      background: 'var(--surface-card)',
      borderLeft: '1px solid var(--border-card)'
    }
  }, React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--text-secondary)',
      marginBottom: 18
    }
  }, "Ce que vous obtenez"), React.createElement(CheckItem, null, "Engagez par la voix ou par texto ", React.createElement("span", {
    style: {
      color: 'var(--wb-orange)'
    }
  }, "en quelques secondes")), React.createElement("div", {
    "aria-hidden": "true",
    style: {
      height: 1,
      background: 'var(--border-hairline)',
      margin: '14px 0'
    }
  }), React.createElement(CheckItem, null, React.createElement("span", {
    style: {
      color: 'var(--wb-orange)'
    }
  }, "Des AI Phones"), " personnalis\u00e9s pour votre entreprise"), React.createElement("div", {
    "aria-hidden": "true",
    style: {
      height: 1,
      background: 'var(--border-hairline)',
      margin: '14px 0'
    }
  }), React.createElement(CheckItem, null, "Chaque lead engag\u00e9, ", React.createElement("span", {
    style: {
      color: 'var(--wb-orange)'
    }
  }, "aucun laiss\u00e9 en attente")), React.createElement("div", {
    "aria-hidden": "true",
    style: {
      height: 1,
      background: 'var(--border-hairline)',
      margin: '14px 0'
    }
  }), React.createElement(CheckItem, null, React.createElement("span", {
    style: {
      color: 'var(--wb-orange)'
    }
  }, "Entra\u00een\u00e9 \u00e0 qualifier et \u00e0 conclure"), ", pas seulement \u00e0 r\u00e9pondre")))));
}
function FounderInsight() {
  return React.createElement(Card, {
    surface: "inverse",
    padding: "lg",
    radius: "xl",
    style: {
      position: 'relative',
      overflow: 'hidden',
      background: '#171717',
      borderColor: '#171717',
      color: '#FFFFFF',
      '--text-primary': '#FFFFFF',
      '--border-hairline': '#3A3A3A'
    }
  }, React.createElement("style", null, ".fi-quote{display:grid;grid-template-columns:auto minmax(0,1fr);gap:18px}.fi-aside{display:flex;align-items:center;gap:16px;padding:20px 0;border-top:1px solid var(--border-hairline);border-bottom:1px solid var(--border-hairline)}@media(max-width:560px){.fi-quote{grid-template-columns:1fr;gap:0}}"), React.createElement(BubbleDrift, {
    density: .8,
    tint: "252,99,6",
    style: {
      position: 'absolute',
      inset: 0,
      opacity: .7,
      pointerEvents: 'none'
    }
  }), React.createElement("div", {
    style: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      gap: 20
    }
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--wb-gold)'
    }
  }, "Le mot du fondateur"), React.createElement("div", {
    className: "fi-quote"
  }, React.createElement("span", {
    "aria-hidden": "true",
    style: {
      fontFamily: 'Georgia,serif',
      fontSize: 64,
      lineHeight: .8,
      fontWeight: 700,
      color: 'var(--wb-orange)'
    }
  }, "\u201C"), React.createElement("p", {
    style: {
      fontSize: 17,
      lineHeight: 1.62,
      fontWeight: 600,
      color: '#FFFFFF'
    }
  }, "Apr\u00e8s 10 ans \u00e0 diriger une agence de marketing, j\u2019ai compris une chose essentielle\u00a0: g\u00e9n\u00e9rer des leads et leur r\u00e9pondre rapidement sont tout aussi importants. Vous pouvez consacrer des milliers \u00e0 attirer de nouvelles occasions d\u2019affaires, mais si vous ne r\u00e9pondez pas en quelques minutes, ou m\u00eame en quelques secondes, vous risquez de perdre le lead. Votre co\u00fbt d\u2019acquisition augmente, l\u2019occasion dispara\u00eet et, soudain, c\u2019est votre concurrent qui profite de vos efforts de marketing. Il y a aussi un avantage que la plupart des gens ratent\u00a0: quand vous r\u00e9pondez \u00e0 chaque appel et que vous faites le suivi, vous obtenez plus d\u2019avis, et plus d\u2019avis signifient que Google vous montre \u00e0 plus de gens. Le t\u00e9l\u00e9phone qui sauve le lead d\u2019aujourd\u2019hui est aussi celui qui vous apporte l\u2019occasion de demain.")), React.createElement("div", {
    className: "fi-aside"
  }, React.createElement("div", {
    style: {
      flex: '0 0 auto',
      width: 46,
      height: 46,
      borderRadius: '50%',
      background: 'rgba(252,99,6,.1)',
      border: '1px solid rgba(252,99,6,.32)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React.createElement(Orbit, {
    size: 26,
    state: "listening",
    detail: true,
    basePath: A
  })), React.createElement("p", {
    style: {
      fontSize: 18,
      fontWeight: 800,
      letterSpacing: '-.01em',
      lineHeight: 1.4,
      textTransform: 'uppercase',
      color: '#FFFFFF'
    }
  }, "Vous avez g\u00e9n\u00e9r\u00e9 la demande. ", React.createElement("span", {
    style: {
      color: 'var(--wb-orange)'
    }
  }, "Ne laissez pas vos concurrents prendre vos clients!"))), React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 12
    }
  }, React.createElement("img", {
    src: A + 'founder.png',
    alt: "Georges Harb, fondateur de WinBoost.ai",
    style: {
      width: 44,
      height: 44,
      borderRadius: '50%',
      objectFit: 'cover',
      border: '1px solid #3A3A3A',
      flex: '0 0 auto'
    }
  }), React.createElement("div", null, React.createElement("div", {
    style: {
      fontSize: 14,
      fontWeight: 800,
      color: '#FFFFFF'
    }
  }, "Fondateur, WinBoost.ai"), React.createElement("div", {
    className: "mono",
    style: {
      color: '#B8B8B8'
    }
  }, "Georges Harb")))));
}
function SpeedFlowMobile() {
  var W = 340,
    H = 735,
    R = [115, 237, 359, 481, 603],
    L = 44,
    RX = 300,
    r = 30,
    JX = 134,
    TL = 176,
    CX = 170,
    TILE_W = 210;
  var JY = R[4],
    UP = JY - 52,
    DN = JY + 68;
  var trunk = 'M45,' + R[0] + ' L' + (RX - r) + ',' + R[0] + ' A' + r + ',' + r + ' 0 0 1 ' + RX + ',' + (R[0] + r) + ' L' + RX + ',' + (R[1] - r) + ' A' + r + ',' + r + ' 0 0 1 ' + (RX - r) + ',' + R[1] + ' L' + (L + r) + ',' + R[1] + ' A' + r + ',' + r + ' 0 0 0 ' + L + ',' + (R[1] + r) + ' L' + L + ',' + (R[2] - r) + ' A' + r + ',' + r + ' 0 0 0 ' + (L + r) + ',' + R[2] + ' L' + (RX - r) + ',' + R[2] + ' A' + r + ',' + r + ' 0 0 1 ' + RX + ',' + (R[2] + r) + ' L' + RX + ',' + (R[3] - r) + ' A' + r + ',' + r + ' 0 0 1 ' + (RX - r) + ',' + R[3] + ' L' + (L + r) + ',' + R[3] + ' A' + r + ',' + r + ' 0 0 0 ' + L + ',' + (R[3] + r) + ' L' + L + ',' + (R[4] - r) + ' A' + r + ',' + r + ' 0 0 0 ' + (L + r) + ',' + R[4] + ' L' + JX + ',' + JY;
  var biz = 'M' + JX + ',' + JY + ' C' + (JX + 16) + ',' + (JY - 16) + ' ' + (JX + 18) + ',' + UP + ' ' + (JX + 32) + ',' + UP + ' L' + TL + ',' + UP;
  var cus = 'M' + JX + ',' + JY + ' C' + (JX + 18) + ',' + (JY + 24) + ' ' + (JX + 20) + ',' + DN + ' ' + (JX + 34) + ',' + DN + ' L' + TL + ',' + DN;
  var checkpoints = [{
    t: 'RAPIDIT\u00c9',
    b: '\u00c0 quelle vitesse vous accordez toute votre attention'
  }, {
    t: '\u00c9LAN',
    b: 'L\u2019int\u00e9r\u00eat r\u00e9el se poursuit'
  }, {
    t: 'CONFIANCE',
    b: 'L\u2019\u00e9lan cr\u00e9e la confiance pour continuer'
  }, {
    t: 'OCCASION',
    b: 'Un r\u00e9sultat clair et souhait\u00e9 pour les deux'
  }];
  var root = React.useRef(null),
    orbitEl = React.useRef(null),
    humanEl = React.useRef(null);
  var trunkEl = React.useRef(null),
    bizEl = React.useRef(null),
    cusEl = React.useRef(null);
  var dT = React.useRef(null),
    dB = React.useRef(null),
    dC = React.useRef(null),
    yM = React.useRef(null);
  var burstB = React.useRef(null),
    burstC = React.useRef(null);
  React.useEffect(function () {
    var NS = 'http://www.w3.org/2000/svg';
    var trunk$ = trunkEl.current,
      biz$ = bizEl.current,
      cus$ = cusEl.current;
    if (!trunk$ || !biz$ || !cus$) return;
    var sub = function sub(el, a, b) {
      var pts = [],
        dir = b >= a ? 1 : -1,
        st = 1.5,
        len = el.getTotalLength();
      a = Math.max(0, Math.min(len, a));
      b = Math.max(0, Math.min(len, b));
      for (var d = a; dir > 0 ? d < b : d > b; d += dir * st) {
        var p = el.getPointAtLength(d);
        pts.push(p.x.toFixed(2) + ',' + p.y.toFixed(2));
      }
      var e = el.getPointAtLength(b);
      pts.push(e.x.toFixed(2) + ',' + e.y.toFixed(2));
      return 'M' + pts.join(' L');
    };
    var YL = 16,
      GAP = 5,
      tl = trunk$.getTotalLength();
    yM.current.setAttribute('d', sub(trunk$, tl - YL, tl) + ' ' + sub(biz$, 0, YL) + ' ' + sub(cus$, 0, YL));
    dT.current.setAttribute('d', sub(trunk$, tl - YL - GAP, 0));
    dB.current.setAttribute('d', sub(biz$, YL + GAP, biz$.getTotalLength()));
    dC.current.setAttribute('d', sub(cus$, YL + GAP, cus$.getTotalLength()));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      orbitEl.current.style.display = 'none';
      humanEl.current.style.display = 'none';
      return;
    }
    var mk = function mk(d) {
      var p = document.createElementNS(NS, 'path');
      p.setAttribute('d', d);
      return p;
    };
    var strip = function strip(d) {
      return d.replace(/^M[\d.]+,[\d.]+\s*/, '');
    };
    var bizP = mk(trunk + ' ' + strip(biz)),
      cusP = mk(trunk + ' ' + strip(cus));
    var bizTravel = bizP.getTotalLength() - 5,
      cusTravel = cusP.getTotalLength() - 5;
    var ease = function ease(u) {
      var x1 = .35,
        y1 = .09,
        x2 = .7,
        y2 = .35;
      var lo = 0,
        hi = 1,
        t = u;
      for (var i = 0; i < 24; i++) {
        t = (lo + hi) / 2;
        var x = 3 * (1 - t) * (1 - t) * t * x1 + 3 * (1 - t) * t * t * x2 + t * t * t;
        if (x < u) lo = t;else hi = t;
      }
      return 3 * (1 - t) * (1 - t) * t * y1 + 3 * (1 - t) * t * t * y2 + t * t * t;
    };
    var DURATION = 6200,
      PAUSE = 250,
      LOOP = DURATION + PAUSE,
      TRAIL = 30;
    var DOTS = [[0, 0, 3.5, 0], [16, -7, 3, .05], [-15, -9, 3, .1], [10, 14, 2.5, .03], [-11, 12, 2.5, .08], [0, -19, 3, .06], [20, 4, 2, .04]],
      K = .9;
    var burst = function burst(g, x, y) {
      var ps = _toConsumableArray(g.children).map(function (c, i) {
        return {
          el: c,
          ox: DOTS[i][0] * K,
          oy: DOTS[i][1] * K,
          r: DOTS[i][2] * K,
          delay: DOTS[i][3] * 1000
        };
      });
      return {
        x: x,
        y: y,
        ps: ps,
        start: -1
      };
    };
    var bB = burst(burstB.current, TL - 5, UP),
      bC = burst(burstC.current, TL - 5, DN);
    var easeOut = function easeOut(k) {
      return 1 - (1 - k) * (1 - k);
    };
    var draw = function draw(b, ts) {
      if (b.start < 0) return;
      var alive = false;
      b.ps.forEach(function (p) {
        var t = ts - b.start - p.delay;
        var op = 0,
          sc = .3;
        if (t < 0) {
          alive = true;
        } else if (t < 90) {
          var e = easeOut(t / 90);
          op = e;
          sc = .3 + .7 * e;
          alive = true;
        } else if (t < 300) {
          var _e = easeOut((t - 90) / 210);
          op = 1 - _e;
          sc = 1 + .6 * _e;
          alive = true;
        }
        p.el.setAttribute('cx', (b.x + p.ox * sc).toFixed(2));
        p.el.setAttribute('cy', (b.y + p.oy * sc).toFixed(2));
        p.el.setAttribute('r', (p.r * sc).toFixed(2));
        p.el.setAttribute('opacity', op.toFixed(2));
      });
      if (!alive) b.start = -1;
    };
    var raf = 0,
      t0 = null,
      wasVisible = false,
      fireB = false,
      fireC = false,
      onScreen = typeof IntersectionObserver === 'undefined';
    var _frame = function frame(ts) {
      raf = 0;
      if (!onScreen) {
        wasVisible = false;
        orbitEl.current.style.opacity = 0;
        humanEl.current.style.opacity = 0;
        return;
      }
      raf = requestAnimationFrame(_frame);
      if (!wasVisible) {
        wasVisible = true;
        t0 = ts;
        fireB = false;
        fireC = false;
      }
      var el = (ts - t0) % LOOP;
      if (el < DURATION) {
        var u = el / DURATION,
          so = ease(u) * bizTravel,
          a = bizP.getPointAtLength(so);
        orbitEl.current.style.left = a.x / W * 100 + '%';
        orbitEl.current.style.top = a.y / H * 100 + '%';
        orbitEl.current.style.opacity = Math.min(1, u / .03);
        var k = Math.max(0, Math.min(1, (so - tl) / (bizTravel - tl))),
          sh = Math.max(0, so - TRAIL * (1 - k));
        var b = cusP.getPointAtLength(Math.min(sh, cusTravel));
        humanEl.current.setAttribute('transform', 'translate(' + b.x + ',' + b.y + ')');
        humanEl.current.style.opacity = Math.min(1, u / .03);
        if (el < DURATION * .5) {
          fireB = false;
          fireC = false;
        }
      } else {
        orbitEl.current.style.opacity = 0;
        humanEl.current.style.opacity = 0;
        if (!fireB) {
          fireB = true;
          bB.start = ts;
        }
        if (!fireC) {
          fireC = true;
          bC.start = ts;
        }
      }
      draw(bB, ts);
      draw(bC, ts);
    };
    var io = onScreen ? null : new IntersectionObserver(function (es) {
      onScreen = es[es.length - 1].isIntersecting;
      if (!raf) raf = requestAnimationFrame(_frame);
    });
    if (io) io.observe(root.current);
    raf = requestAnimationFrame(_frame);
    return function () {
      cancelAnimationFrame(raf);
      if (io) io.disconnect();
    };
  }, []);
  React.useEffect(function () {
    var el = root.current;
    if (!el) return;
    var st = el.querySelector('.sfm-stage');
    var set = function set() {
      var w = st.getBoundingClientRect().width;
      el.style.setProperty('--k', Math.max(.7, Math.min(1.25, w / 340)).toFixed(3));
    };
    set();
    var ro = null;
    if (window.ResizeObserver) {
      ro = new ResizeObserver(set);
      ro.observe(st);
    }
    window.addEventListener('resize', set);
    return function () {
      if (ro) ro.disconnect();
      window.removeEventListener('resize', set);
    };
  }, []);
  var css = '.sfm{width:100%;max-width:400px;margin:0 auto}' + '.sfm-stage{position:relative}' + '.sfm-svg{display:block;width:100%;height:auto;overflow:visible}' + '.sfm-ck{position:absolute;width:' + TILE_W / W * 100 + '%;height:calc(76px*var(--k,1));box-sizing:border-box;display:flex;flex-direction:column;justify-content:center;padding:calc(6px*var(--k,1)) calc(14px*var(--k,1));background:#171717;border-radius:calc(14px*var(--k,1));text-align:center;transform:translateY(-100%)}' + '.sfm-ck b{display:block;font-size:calc(16px*var(--k,1));font-weight:800;letter-spacing:.02em;line-height:1.2;color:#fff}' + '.sfm-ck span{display:block;font-size:calc(13px*var(--k,1));line-height:1.35;margin-top:calc(3px*var(--k,1));color:#D4D4D4}' + '.sfm-out{position:absolute;left:' + TL / W * 100 + '%;width:' + 154 / W * 100 + '%;box-sizing:border-box;padding:calc(8px*var(--k,1)) calc(10px*var(--k,1));border-radius:calc(14px*var(--k,1));transform:translateY(-50%)}' + '.sfm-out em{display:block;font-style:normal;font-size:calc(12.5px*var(--k,1));font-weight:800;letter-spacing:.02em;line-height:1.2;text-transform:uppercase;margin-bottom:calc(3px*var(--k,1));color:#171717}' + '.sfm-out b{display:block;font-size:calc(13px*var(--k,1));font-weight:700;line-height:1.3;color:#171717}' + '.sfm-biz{background:linear-gradient(135deg,#FFAE06 0%,#FC6306 100%);box-shadow:0 6px 16px rgba(252,99,6,.22)}' + '.sfm-cus{background:linear-gradient(135deg,#FFE066 0%,#FFB800 100%);box-shadow:0 6px 16px rgba(255,184,0,.25)}' + '.sfm-fx{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:5}' + '.sfm-fx svg{position:absolute;left:0;top:0;width:100%;height:auto;overflow:visible}' + '.sfm-orbit{position:absolute;width:40px;height:40px;transform:translate(-50%,-50%) scale(var(--k,1));opacity:0;left:' + 45 / W * 100 + '%;top:' + R[0] / H * 100 + '%}';
  return React.createElement("div", {
    className: "sfm",
    ref: root
  }, React.createElement("style", null, css), React.createElement("div", {
    className: "sf-head",
    style: {
      textAlign: 'center',
      marginBottom: 14
    }
  }, React.createElement("h3", {
    style: {
      fontSize: 24,
      fontWeight: 800,
      letterSpacing: '-.02em',
      color: 'var(--wb-charcoal)',
      margin: '0 0 6px',
      lineHeight: 1.2
    }
  }, "Pourquoi la rapidit\u00e9 de r\u00e9ponse fait gagner plus de leads"), React.createElement("p", {
    style: {
      fontSize: 14.5,
      color: 'var(--text-secondary)',
      margin: 0,
      lineHeight: 1.45
    }
  }, "Une attention donn\u00e9e rapidement devient de l\u2019\u00e9lan, puis de la confiance, puis une v\u00e9ritable occasion, pour l\u2019entreprise et le client, ensemble.")), React.createElement("div", {
    className: "sfm-stage"
  }, React.createElement("svg", {
    className: "sfm-svg",
    viewBox: '0 0 ' + W + ' ' + H,
    "aria-hidden": "true"
  }, React.createElement("defs", null, React.createElement("linearGradient", {
    id: "sfmGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFAE06"
  }), React.createElement("stop", {
    offset: "25%",
    stopColor: "#FC6306"
  }), React.createElement("stop", {
    offset: "50%",
    stopColor: "#FFAE06"
  }), React.createElement("stop", {
    offset: "75%",
    stopColor: "#FC6306"
  }), React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFAE06"
  })), React.createElement("pattern", {
    id: "sfmChecker",
    width: "5",
    height: "5",
    patternUnits: "userSpaceOnUse"
  }, React.createElement("rect", {
    width: "5",
    height: "5",
    fill: "#fff"
  }), React.createElement("rect", {
    width: "2.5",
    height: "2.5",
    fill: "#171717"
  }), React.createElement("rect", {
    x: "2.5",
    y: "2.5",
    width: "2.5",
    height: "2.5",
    fill: "#171717"
  }))), React.createElement("path", {
    ref: trunkEl,
    d: trunk,
    fill: "none",
    stroke: "url(#sfmGrad)",
    strokeWidth: "18",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    ref: bizEl,
    d: biz,
    fill: "none",
    stroke: "url(#sfmGrad)",
    strokeWidth: "18",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    ref: cusEl,
    d: cus,
    fill: "none",
    stroke: "url(#sfmGrad)",
    strokeWidth: "18",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: trunk,
    fill: "none",
    stroke: "#171717",
    strokeWidth: "14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: biz,
    fill: "none",
    stroke: "#171717",
    strokeWidth: "14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: cus,
    fill: "none",
    stroke: "#171717",
    strokeWidth: "14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: "1.5",
    strokeDasharray: "9 7",
    opacity: ".85"
  }, React.createElement("path", {
    ref: dT
  }), React.createElement("path", {
    ref: dB
  }), React.createElement("path", {
    ref: dC
  })), React.createElement("path", {
    ref: yM,
    fill: "none",
    stroke: "#fff",
    strokeWidth: "1.7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("rect", {
    x: "35",
    y: R[0] - 11,
    width: "10",
    height: "22",
    fill: "url(#sfmChecker)"
  }), React.createElement("rect", {
    x: TL - 10,
    y: UP - 11,
    width: "10",
    height: "22",
    fill: "url(#sfmChecker)"
  }), React.createElement("rect", {
    x: TL - 10,
    y: DN - 11,
    width: "10",
    height: "22",
    fill: "url(#sfmChecker)"
  }), R.slice(0, 4).map(function (y, i) {
    return React.createElement("line", {
      key: i,
      x1: CX,
      y1: y - 21,
      x2: CX,
      y2: y - 9,
      stroke: "#FC6306",
      strokeWidth: "2.5"
    });
  })), checkpoints.map(function (c, i) {
    return React.createElement("div", {
      key: c.t,
      className: "sfm-ck",
      style: {
        left: (CX - TILE_W / 2) / W * 100 + '%',
        top: (R[i] - 21) / H * 100 + '%'
      }
    }, React.createElement("b", null, c.t), React.createElement("span", null, c.b));
  }), React.createElement("div", {
    className: "sfm-out sfm-biz",
    style: {
      top: UP / H * 100 + '%'
    }
  }, React.createElement("em", null, "Pour l\u2019entreprise"), React.createElement("b", null, "Plus de leads conclus, plus de revenus et de croissance")), React.createElement("div", {
    className: "sfm-out sfm-cus",
    style: {
      top: DN / H * 100 + '%'
    }
  }, React.createElement("em", null, "Pour le client"), React.createElement("b", null, "Obtient ce dont il avait besoin, vite et satisfait")), React.createElement("div", {
    className: "sfm-fx",
    "aria-hidden": "true"
  }, React.createElement("svg", {
    viewBox: '0 0 ' + W + ' ' + H
  }, React.createElement("g", {
    ref: humanEl,
    style: {
      opacity: 0
    },
    transform: 'translate(45,' + R[0] + ')'
  }, React.createElement("g", {
    transform: "translate(-9.5,-18)"
  }, React.createElement("path", {
    d: "M9.5,13 C15,13 19,18.8 19,29 L0,29 C0,18.8 4,13 9.5,13 Z",
    fill: "#F5B700"
  }), React.createElement("circle", {
    cx: "9.5",
    cy: "6.3",
    r: "5.7",
    fill: "#F5B700"
  }))), React.createElement("g", {
    ref: burstB
  }, React.createElement("circle", {
    fill: "#FC6306",
    r: "0",
    opacity: "0"
  }), React.createElement("circle", {
    fill: "#FFAE06",
    r: "0",
    opacity: "0"
  }), React.createElement("circle", {
    fill: "#FC6306",
    r: "0",
    opacity: "0"
  }), React.createElement("circle", {
    fill: "#FFAE06",
    r: "0",
    opacity: "0"
  }), React.createElement("circle", {
    fill: "#FC6306",
    r: "0",
    opacity: "0"
  }), React.createElement("circle", {
    fill: "#FFAE06",
    r: "0",
    opacity: "0"
  }), React.createElement("circle", {
    fill: "#FC6306",
    r: "0",
    opacity: "0"
  })), React.createElement("g", {
    ref: burstC
  }, React.createElement("circle", {
    fill: "#F5B700",
    r: "0",
    opacity: "0"
  }), React.createElement("circle", {
    fill: "#FFAE06",
    r: "0",
    opacity: "0"
  }), React.createElement("circle", {
    fill: "#F5B700",
    r: "0",
    opacity: "0"
  }), React.createElement("circle", {
    fill: "#FFAE06",
    r: "0",
    opacity: "0"
  }), React.createElement("circle", {
    fill: "#F5B700",
    r: "0",
    opacity: "0"
  }), React.createElement("circle", {
    fill: "#FFAE06",
    r: "0",
    opacity: "0"
  }), React.createElement("circle", {
    fill: "#F5B700",
    r: "0",
    opacity: "0"
  }))), React.createElement("div", {
    className: "sfm-orbit",
    ref: orbitEl
  }, React.createElement(Orbit, {
    size: 40,
    state: "listening",
    basePath: A
  })))), React.createElement("div", {
    className: "sf-tag",
    style: {
      textAlign: 'center',
      marginTop: 14
    }
  }, React.createElement("span", {
    style: {
      fontSize: 19,
      fontWeight: 800,
      letterSpacing: '-.01em',
      color: 'var(--wb-charcoal)'
    }
  }, "Parce que nous partageons le "), React.createElement("span", {
    style: {
      fontSize: 19,
      fontWeight: 800,
      letterSpacing: '-.01em',
      background: 'linear-gradient(90deg,#FFAE06,#FC6306)',
      WebkitBackgroundClip: 'text',
      backgroundClip: 'text',
      color: 'transparent'
    }
  }, "desire to WIN"), React.createElement("span", {
    style: {
      fontSize: 19,
      fontWeight: 800,
      letterSpacing: '-.01em',
      color: 'var(--wb-charcoal)'
    }
  }, ".")));
}
function SpeedFlow() {
  var dRoot = React.useRef(null),
    dOrbit = React.useRef(null),
    dHuman = React.useRef(null),
    dBurstB = React.useRef(null),
    dBurstC = React.useRef(null);
  React.useEffect(function () {
    var NS = 'http://www.w3.org/2000/svg';
    var TRUNK = 'M60,540 L680,540 A100,100 0 0,0 680,340 L160,340 A100,100 0 0,1 160,140 L780,140';
    var mk = function mk(d) {
      var p = document.createElementNS(NS, 'path');
      p.setAttribute('d', d);
      return p;
    };
    var bizP = mk(TRUNK + ' C802,96 818,60 846,60 L965,60'),
      cusP = mk(TRUNK + ' C802,184 818,220 846,220 L965,220');
    var bizLen = bizP.getTotalLength(),
      cusLen = cusP.getTotalLength(),
      tl = mk(TRUNK).getTotalLength();
    var orbit = dOrbit.current,
      human = dHuman.current;
    if (!orbit || !human) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      orbit.style.display = 'none';
      human.style.display = 'none';
      return;
    }
    var ease = function ease(u) {
      var x1 = .35,
        y1 = .09,
        x2 = .7,
        y2 = .35;
      var lo = 0,
        hi = 1,
        t = u;
      for (var i = 0; i < 24; i++) {
        t = (lo + hi) / 2;
        var x = 3 * (1 - t) * (1 - t) * t * x1 + 3 * (1 - t) * t * t * x2 + t * t * t;
        if (x < u) lo = t;else hi = t;
      }
      return 3 * (1 - t) * (1 - t) * t * y1 + 3 * (1 - t) * t * t * y2 + t * t * t;
    };
    var DURATION = 5200,
      PAUSE = 250,
      LOOP = DURATION + PAUSE,
      TRAIL = 70;
    var DOTS = [[0, 0, 3.5, 0], [16, -7, 3, .05], [-15, -9, 3, .1], [10, 14, 2.5, .03], [-11, 12, 2.5, .08], [0, -19, 3, .06], [20, 4, 2, .04]];
    var burst = function burst(g, x, y) {
      return {
        x: x,
        y: y,
        start: -1,
        ps: _toConsumableArray(g.children).map(function (c, i) {
          return {
            el: c,
            ox: DOTS[i][0],
            oy: DOTS[i][1],
            r: DOTS[i][2],
            delay: DOTS[i][3] * 1000
          };
        })
      };
    };
    var bB = burst(dBurstB.current, 965, 60),
      bC = burst(dBurstC.current, 965, 220);
    var easeOut = function easeOut(k) {
      return 1 - (1 - k) * (1 - k);
    };
    var draw = function draw(b, ts) {
      if (b.start < 0) return;
      var alive = false;
      b.ps.forEach(function (p) {
        var t = ts - b.start - p.delay;
        var op = 0,
          sc = .3;
        if (t < 0) {
          alive = true;
        } else if (t < 90) {
          var e = easeOut(t / 90);
          op = e;
          sc = .3 + .7 * e;
          alive = true;
        } else if (t < 300) {
          var _e2 = easeOut((t - 90) / 210);
          op = 1 - _e2;
          sc = 1 + .6 * _e2;
          alive = true;
        }
        p.el.setAttribute('cx', (b.x + p.ox * sc).toFixed(2));
        p.el.setAttribute('cy', (b.y + p.oy * sc).toFixed(2));
        p.el.setAttribute('r', (p.r * sc).toFixed(2));
        p.el.setAttribute('opacity', op.toFixed(2));
      });
      if (!alive) b.start = -1;
    };
    var raf = 0,
      t0 = null,
      wasVisible = false,
      fireB = false,
      fireC = false,
      onScreen = typeof IntersectionObserver === 'undefined';
    var _frame2 = function frame(ts) {
      raf = 0;
      if (!onScreen) {
        wasVisible = false;
        orbit.style.opacity = 0;
        human.style.opacity = 0;
        return;
      }
      raf = requestAnimationFrame(_frame2);
      if (!wasVisible) {
        wasVisible = true;
        t0 = ts;
        fireB = false;
        fireC = false;
      }
      var el = (ts - t0) % LOOP;
      if (el < DURATION) {
        var u = el / DURATION,
          so = ease(u) * bizLen,
          a = bizP.getPointAtLength(so);
        orbit.setAttribute('x', (a.x - 32).toFixed(2));
        orbit.setAttribute('y', (a.y - 32).toFixed(2));
        orbit.style.opacity = Math.min(1, u / .03);
        var k = Math.max(0, Math.min(1, (so - tl) / (bizLen - tl))),
          sh = Math.max(0, so - TRAIL * (1 - k));
        var b = cusP.getPointAtLength(Math.min(sh, cusLen));
        human.setAttribute('transform', 'translate(' + b.x.toFixed(2) + ',' + b.y.toFixed(2) + ')');
        human.style.opacity = Math.min(1, u / .03);
        if (el < DURATION * .5) {
          fireB = false;
          fireC = false;
        }
      } else {
        orbit.style.opacity = 0;
        human.style.opacity = 0;
        if (!fireB) {
          fireB = true;
          bB.start = ts;
        }
        if (!fireC) {
          fireC = true;
          bC.start = ts;
        }
      }
      draw(bB, ts);
      draw(bC, ts);
    };
    var io = onScreen ? null : new IntersectionObserver(function (es) {
      onScreen = es[es.length - 1].isIntersecting;
      if (!raf) raf = requestAnimationFrame(_frame2);
    });
    if (io) io.observe(dRoot.current);
    raf = requestAnimationFrame(_frame2);
    return function () {
      cancelAnimationFrame(raf);
      if (io) io.disconnect();
    };
  }, []);
  return React.createElement("div", {
    style: {
      position: 'relative',
      width: '100%'
    }
  }, React.createElement("style", null, '.sf-badge{opacity:0;animation:sfFade .5s .11s cubic-bezier(.2,.8,.25,1) forwards}.sf-card{opacity:0;animation:sfFade .5s 1.26s cubic-bezier(.2,.8,.25,1) forwards}.sf-tag{opacity:0;animation:sfFade .5s 1.43s cubic-bezier(.2,.8,.25,1) forwards}@keyframes sfFade{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}.sf-draw{stroke-dasharray:2900;animation:sfDraw 1.9s cubic-bezier(.3,.7,.3,1) forwards}@keyframes sfDraw{from{stroke-dashoffset:2900}to{stroke-dashoffset:0}}.sf-orbit{animation:sfGoOrbit 3s cubic-bezier(.4,.05,.3,.95) infinite}@keyframes sfGoOrbit{0%{offset-distance:0%;opacity:0}3%{opacity:1}100%{offset-distance:100%;opacity:1}}.sf-human{animation:sfGoHuman 3s .08s cubic-bezier(.4,.05,.3,.95) infinite}@keyframes sfGoHuman{0%{offset-distance:0%;opacity:0}3%{opacity:1}100%{offset-distance:100%;opacity:1}}.sf-burst circle{animation:sfBurst 3s ease-out infinite}@keyframes sfBurst{0%,90%{opacity:0;transform:scale(.3)}93%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(1.6)}}@media(max-width:900px){.sf-head h3{font-size:26px!important}.sf-head p{font-size:15px!important}.sf-t1{font-size:30px!important}.sf-t2{font-size:20px!important}.sf-tile-h{font-size:22px!important}.sf-tile-b{font-size:26px!important}.sf-tag span{font-size:21px!important}}.sf-mobile{display:none}@media(max-width:768px){.sf-desktop{display:none}.sf-mobile{display:block}}'), React.createElement("div", {
    className: "sf-desktop",
    ref: dRoot
  }, React.createElement("div", {
    className: "sf-head",
    style: {
      textAlign: 'center',
      marginBottom: 14
    }
  }, React.createElement("h3", {
    style: {
      fontSize: 'clamp(22px,2.2vw,28px)',
      fontWeight: 800,
      letterSpacing: '-.02em',
      color: 'var(--wb-charcoal)',
      margin: '0 0 6px'
    }
  }, "Pourquoi la rapidit\u00e9 de r\u00e9ponse fait gagner plus de leads"), React.createElement("p", {
    style: {
      fontSize: 14,
      color: 'var(--text-secondary)',
      margin: '0 auto',
      maxWidth: 620
    }
  }, "Une attention donn\u00e9e rapidement devient de l\u2019\u00e9lan, puis de la confiance, puis une v\u00e9ritable occasion, pour l\u2019entreprise et le client, ensemble.")), React.createElement("svg", {
    viewBox: "0 0 1340 620",
    style: {
      width: '100%',
      height: 'auto',
      display: 'block',
      overflow: 'visible'
    }
  }, React.createElement("defs", null, React.createElement("linearGradient", {
    id: "sfGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFAE06"
  }), React.createElement("stop", {
    offset: "25%",
    stopColor: "#FC6306"
  }), React.createElement("stop", {
    offset: "50%",
    stopColor: "#FFAE06"
  }), React.createElement("stop", {
    offset: "75%",
    stopColor: "#FC6306"
  }), React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFAE06"
  })), React.createElement("pattern", {
    id: "sfChecker",
    width: "9",
    height: "9",
    patternUnits: "userSpaceOnUse"
  }, React.createElement("rect", {
    width: "9",
    height: "9",
    fill: "#fff"
  }), React.createElement("rect", {
    width: "4.5",
    height: "4.5",
    fill: "#171717"
  }), React.createElement("rect", {
    x: "4.5",
    y: "4.5",
    width: "4.5",
    height: "4.5",
    fill: "#171717"
  }))), React.createElement("path", {
    d: "M60,540 L680,540 A100,100 0 0,0 680,340 L160,340 A100,100 0 0,1 160,140 L780,140",
    fill: "none",
    stroke: "url(#sfGrad)",
    strokeWidth: "48",
    strokeLinecap: "butt",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M780,140 C802,96 818,60 846,60 L965,60",
    fill: "none",
    stroke: "url(#sfGrad)",
    strokeWidth: "48",
    strokeLinecap: "butt",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M780,140 C802,184 818,220 846,220 L965,220",
    fill: "none",
    stroke: "url(#sfGrad)",
    strokeWidth: "48",
    strokeLinecap: "butt",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    className: "sf-draw",
    d: "M60,540 L680,540 A100,100 0 0,0 680,340 L160,340 A100,100 0 0,1 160,140 L780,140",
    fill: "none",
    stroke: "#171717",
    strokeWidth: "40",
    strokeLinecap: "butt",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M780,140 C802,96 818,60 846,60 L965,60",
    fill: "none",
    stroke: "#171717",
    strokeWidth: "40",
    strokeLinecap: "butt",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M780,140 C802,184 818,220 846,220 L965,220",
    fill: "none",
    stroke: "#171717",
    strokeWidth: "40",
    strokeLinecap: "butt",
    strokeLinejoin: "round"
  }), React.createElement("circle", {
    cx: "780",
    cy: "140",
    r: "20",
    fill: "#171717"
  }), React.createElement("path", {
    d: "M60,540 L680,540 A100,100 0 0,0 680,340 L160,340 A100,100 0 0,1 160,140 L780,140",
    fill: "none",
    stroke: "#fff",
    strokeWidth: "2.5",
    strokeDasharray: "15 12",
    opacity: ".85"
  }), React.createElement("path", {
    d: "M780,140 C802,96 818,60 846,60 L965,60",
    fill: "none",
    stroke: "#fff",
    strokeWidth: "2.5",
    strokeDasharray: "15 12",
    opacity: ".85"
  }), React.createElement("path", {
    d: "M780,140 C802,184 818,220 846,220 L965,220",
    fill: "none",
    stroke: "#fff",
    strokeWidth: "2.5",
    strokeDasharray: "15 12",
    opacity: ".85"
  }), React.createElement("rect", {
    x: "60",
    y: "520",
    width: "22",
    height: "40",
    fill: "url(#sfChecker)"
  }), React.createElement("rect", {
    x: "953",
    y: "40",
    width: "24",
    height: "40",
    fill: "url(#sfChecker)"
  }), React.createElement("rect", {
    x: "953",
    y: "200",
    width: "24",
    height: "40",
    fill: "url(#sfChecker)"
  }), React.createElement("g", {
    className: "sf-badge",
    style: {
      animationDelay: '.25s'
    }
  }, React.createElement("rect", {
    x: "175",
    y: "400",
    width: "250",
    height: "104",
    rx: "16",
    fill: "#171717"
  }), React.createElement("text", {
    className: "sf-t1",
    x: "300",
    y: "439",
    textAnchor: "middle",
    fontSize: "26",
    fontWeight: "800",
    fill: "#fff",
    letterSpacing: ".02em"
  }, "RAPIDIT\u00c9"), React.createElement("text", {
    className: "sf-t2",
    x: "300",
    y: "467",
    textAnchor: "middle",
    fontSize: "17",
    fill: "#C9C9C9"
  }, "\u00c0 quelle vitesse vous accordez"), React.createElement("text", {
    className: "sf-t2",
    x: "300",
    y: "489",
    textAnchor: "middle",
    fontSize: "17",
    fill: "#C9C9C9"
  }, "toute votre attention"), React.createElement("path", {
    d: "M300,504 L300,518",
    stroke: "#FC6306",
    strokeWidth: "3"
  })), React.createElement("g", {
    className: "sf-badge",
    style: {
      animationDelay: '.6s'
    }
  }, React.createElement("rect", {
    x: "295",
    y: "200",
    width: "250",
    height: "104",
    rx: "16",
    fill: "#171717"
  }), React.createElement("text", {
    className: "sf-t1",
    x: "420",
    y: "239",
    textAnchor: "middle",
    fontSize: "26",
    fontWeight: "800",
    fill: "#fff",
    letterSpacing: ".02em"
  }, "\u00c9LAN"), React.createElement("text", {
    className: "sf-t2",
    x: "420",
    y: "267",
    textAnchor: "middle",
    fontSize: "17",
    fill: "#C9C9C9"
  }, "L\u2019int\u00e9r\u00eat r\u00e9el"), React.createElement("text", {
    className: "sf-t2",
    x: "420",
    y: "289",
    textAnchor: "middle",
    fontSize: "17",
    fill: "#C9C9C9"
  }, "se poursuit"), React.createElement("path", {
    d: "M420,304 L420,318",
    stroke: "#FC6306",
    strokeWidth: "3"
  })), React.createElement("g", {
    className: "sf-badge",
    style: {
      animationDelay: '.95s'
    }
  }, React.createElement("rect", {
    x: "125",
    y: "0",
    width: "250",
    height: "104",
    rx: "16",
    fill: "#171717"
  }), React.createElement("text", {
    className: "sf-t1",
    x: "250",
    y: "39",
    textAnchor: "middle",
    fontSize: "26",
    fontWeight: "800",
    fill: "#fff",
    letterSpacing: ".02em"
  }, "CONFIANCE"), React.createElement("text", {
    className: "sf-t2",
    x: "250",
    y: "67",
    textAnchor: "middle",
    fontSize: "17",
    fill: "#C9C9C9"
  }, "L\u2019\u00e9lan cr\u00e9e"), React.createElement("text", {
    className: "sf-t2",
    x: "250",
    y: "89",
    textAnchor: "middle",
    fontSize: "17",
    fill: "#C9C9C9"
  }, "la confiance pour continuer"), React.createElement("path", {
    d: "M250,104 L250,118",
    stroke: "#FC6306",
    strokeWidth: "3"
  })), React.createElement("g", {
    className: "sf-badge",
    style: {
      animationDelay: '1.3s'
    }
  }, React.createElement("rect", {
    x: "475",
    y: "0",
    width: "250",
    height: "104",
    rx: "16",
    fill: "#171717"
  }), React.createElement("text", {
    className: "sf-t1",
    x: "600",
    y: "39",
    textAnchor: "middle",
    fontSize: "26",
    fontWeight: "800",
    fill: "#fff",
    letterSpacing: ".02em"
  }, "OCCASION"), React.createElement("text", {
    className: "sf-t2",
    x: "600",
    y: "67",
    textAnchor: "middle",
    fontSize: "17",
    fill: "#C9C9C9"
  }, "Un r\u00e9sultat clair"), React.createElement("text", {
    className: "sf-t2",
    x: "600",
    y: "89",
    textAnchor: "middle",
    fontSize: "17",
    fill: "#C9C9C9"
  }, "et souhait\u00e9 pour les deux"), React.createElement("path", {
    d: "M600,104 L600,118",
    stroke: "#FC6306",
    strokeWidth: "3"
  })), React.createElement("g", {
    ref: dBurstB
  }, React.createElement("circle", {
    r: "0",
    opacity: "0",
    fill: "#FC6306"
  }), React.createElement("circle", {
    r: "0",
    opacity: "0",
    fill: "#FFAE06"
  }), React.createElement("circle", {
    r: "0",
    opacity: "0",
    fill: "#FC6306"
  }), React.createElement("circle", {
    r: "0",
    opacity: "0",
    fill: "#FFAE06"
  }), React.createElement("circle", {
    r: "0",
    opacity: "0",
    fill: "#FC6306"
  }), React.createElement("circle", {
    r: "0",
    opacity: "0",
    fill: "#FFAE06"
  }), React.createElement("circle", {
    r: "0",
    opacity: "0",
    fill: "#FC6306"
  })), React.createElement("g", {
    ref: dBurstC
  }, React.createElement("circle", {
    r: "0",
    opacity: "0",
    fill: "#F5B700"
  }), React.createElement("circle", {
    r: "0",
    opacity: "0",
    fill: "#FFAE06"
  }), React.createElement("circle", {
    r: "0",
    opacity: "0",
    fill: "#F5B700"
  }), React.createElement("circle", {
    r: "0",
    opacity: "0",
    fill: "#FFAE06"
  }), React.createElement("circle", {
    r: "0",
    opacity: "0",
    fill: "#F5B700"
  }), React.createElement("circle", {
    r: "0",
    opacity: "0",
    fill: "#FFAE06"
  }), React.createElement("circle", {
    r: "0",
    opacity: "0",
    fill: "#F5B700"
  })), React.createElement("foreignObject", {
    ref: dOrbit,
    x: "-200",
    y: "-200",
    width: "64",
    height: "64",
    style: {
      opacity: 0
    }
  }, React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      width: 64,
      height: 64
    }
  }, React.createElement(Orbit, {
    size: 64,
    state: "listening",
    basePath: A
  }))), React.createElement("g", {
    ref: dHuman,
    style: {
      opacity: 0
    }
  }, React.createElement("g", {
    transform: "translate(-16,-30)"
  }, React.createElement("path", {
    d: "M16,22 C25.4,22 32,30.8 32,48 L0,48 C0,30.8 6.6,22 16,22 Z",
    fill: "#F5B700"
  }), React.createElement("path", {
    d: "M0,48 C0,30.8 6.6,22 16,22 C25.4,22 32,30.8 32,48",
    fill: "none",
    stroke: "#fff",
    strokeWidth: "1.2",
    opacity: ".55"
  }), React.createElement("circle", {
    cx: "16",
    cy: "11",
    r: "9.5",
    fill: "#F5B700"
  }), React.createElement("circle", {
    cx: "16",
    cy: "11",
    r: "9.5",
    fill: "none",
    stroke: "#fff",
    strokeWidth: "1.4",
    opacity: ".7"
  }))), React.createElement("foreignObject", {
    className: "sf-card",
    x: "995",
    y: "-10",
    width: "335",
    height: "140"
  }, React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: 'linear-gradient(135deg,#FFAE06 0%,#FC6306 100%)',
      boxShadow: '0 6px 16px rgba(252,99,6,.22)',
      borderRadius: 14,
      padding: '14px 20px',
      textAlign: 'center',
      height: '100%',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    }
  }, React.createElement("div", {
    className: "sf-tile-h",
    style: {
      fontSize: 20,
      fontWeight: 800,
      textTransform: 'uppercase',
      letterSpacing: '.07em',
      color: '#171717',
      marginBottom: 8,
      lineHeight: 1.15
    }
  }, "Pour l\u2019entreprise"), React.createElement("div", {
    className: "sf-tile-b",
    style: {
      fontSize: 23,
      fontWeight: 800,
      color: '#171717',
      lineHeight: 1.3
    }
  }, "Plus de leads conclus, plus de revenus et de croissance"))), React.createElement("foreignObject", {
    className: "sf-card",
    x: "995",
    y: "150",
    width: "335",
    height: "140",
    style: {
      animationDelay: '3.3s'
    }
  }, React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: 'linear-gradient(135deg,#FFE066 0%,#FFB800 100%)',
      boxShadow: '0 6px 16px rgba(255,184,0,.25)',
      borderRadius: 14,
      padding: '14px 20px',
      textAlign: 'center',
      height: '100%',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    }
  }, React.createElement("div", {
    className: "sf-tile-h",
    style: {
      fontSize: 20,
      fontWeight: 800,
      textTransform: 'uppercase',
      letterSpacing: '.07em',
      color: '#171717',
      marginBottom: 8,
      lineHeight: 1.15
    }
  }, "Pour le client"), React.createElement("div", {
    className: "sf-tile-b",
    style: {
      fontSize: 23,
      fontWeight: 800,
      color: '#171717',
      lineHeight: 1.3
    }
  }, "Obtient ce dont il avait besoin, vite et satisfait")))), React.createElement("div", {
    className: "sf-tag",
    style: {
      textAlign: 'center',
      marginTop: 4
    }
  }, React.createElement("span", {
    style: {
      fontSize: 19,
      fontWeight: 800,
      letterSpacing: '-.01em',
      color: 'var(--wb-charcoal)'
    }
  }, "Parce que nous partageons le "), React.createElement("span", {
    style: {
      fontSize: 19,
      fontWeight: 800,
      letterSpacing: '-.01em',
      background: 'linear-gradient(90deg,#FFAE06,#FC6306)',
      WebkitBackgroundClip: 'text',
      backgroundClip: 'text',
      color: 'transparent'
    }
  }, "desire to WIN"), React.createElement("span", {
    style: {
      fontSize: 19,
      fontWeight: 800,
      letterSpacing: '-.01em',
      color: 'var(--wb-charcoal)'
    }
  }, "."))), React.createElement("div", {
    className: "sf-mobile"
  }, React.createElement(SpeedFlowMobile, null)));
}
function Problem() {
  return React.createElement(Section, {
    id: "problem",
    tight: true,
    style: {
      position: 'relative',
      overflow: 'hidden'
    }
  }, React.createElement("style", null, "@keyframes wbFlowRule{0%{background-position:200% 50%}100%{background-position:0% 50%}}@media (prefers-reduced-motion:reduce){.wb-flow-rule{animation:none!important}}.pb-head{display:flex;flex-direction:column;gap:clamp(18px,2vw,26px)}.pb-copy{display:flex;flex-direction:column;gap:16px}.pb-stats{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:clamp(24px,3vw,56px)}@media(max-width:900px){.pb-stats{grid-template-columns:1fr;gap:22px}}"), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 'clamp(26px,2.8vw,40px)'
    }
  }, React.createElement("div", {
    className: "pb-head"
  }, React.createElement("div", {
    className: "pb-copy"
  }, React.createElement("h2", {
    style: {
      fontSize: 'var(--fs-h2)',
      lineHeight: 'var(--lh-h2)',
      letterSpacing: 'var(--ls-h2)',
      fontWeight: 800
    }
  }, "Votre plus grand frein \u00e0 la croissance n\u2019est pas toujours de g\u00e9n\u00e9rer des leads. ", React.createElement("span", {
    style: {
      color: 'var(--wb-orange)'
    }
  }, "C\u2019est d\u2019accorder \u00e0 chaque occasion l\u2019attention qu\u2019elle m\u00e9rite, quand c\u2019est le plus important.")), React.createElement("p", {
    style: {
      fontSize: 'var(--fs-body)',
      lineHeight: 'var(--lh-body)',
      color: 'var(--text-secondary)'
    }
  }, "Nous ne sommes pas l\u00e0 pour remplacer votre \u00e9quipe, mais pour la soutenir. Nous croyons que les AI Phones fonctionnent mieux quand ils travaillent aux c\u00f4t\u00e9s de vos gens et de vos flux de travail existants, pour aider votre entreprise \u00e0 r\u00e9pondre plus vite, \u00e0 saisir plus d\u2019occasions et \u00e0 donner \u00e0 chaque client l\u2019attention qu\u2019il m\u00e9rite."))), React.createElement(InkBand, {
    tone: "brand"
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 'clamp(26px,2.8vw,40px)'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 14,
      alignItems: 'center',
      textAlign: 'center'
    }
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--text-primary)'
    }
  }, "Le goulot d\u2019\u00e9tranglement de l\u2019attention"), React.createElement("h2", {
    style: {
      fontSize: 'var(--fs-h2)',
      lineHeight: 1.1,
      letterSpacing: '-.03em',
      fontWeight: 800,
      color: 'var(--wb-charcoal)'
    }
  }, "Vous avez travaill\u00e9 fort pour ces leads. Soyez l\u00e0 quand ils appellent.")), React.createElement("div", {
    className: "ao-figs-grid"
  }, React.createElement(AoTile, {
    v: "78 %",
    l: "des appelants",
    c: "ne laissent pas de message vocal."
  }), React.createElement(AoTile, {
    v: "< 60 s",
    l: "fen\u00eatre de r\u00e9ponse",
    c: "avant qu\u2019un lead refroidisse."
  }), React.createElement(AoTile, {
    v: "4,5\u00d7",
    l: "disponibilit\u00e9 de l\u2019AI Phone",
    c: "que celle d\u2019un employ\u00e9 \u00e0 temps plein."
  })))), React.createElement(SpeedFlow, null), React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, React.createElement(Button, {
    variant: "primary",
    size: "lg",
    href: window.WB_PRODUCT_HREF ? window.WB_PRODUCT_HREF('home', 'try-winboost-ai-phone') : '#final-form'
  }, "Essayer le WinBoost AI Phone"))));
}
function InMarketingBlock() {
  return React.createElement(Section, {
    id: "inmarketing",
    tight: true
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 'clamp(34px,3.6vw,56px)'
    }
  }, React.createElement(InMarketingCopy, null), React.createElement(InMarketingSystem, null), React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, React.createElement(Button, {
    variant: "primary",
    size: "lg",
    arrow: true,
    href: window.WB_PRODUCT_HREF ? window.WB_PRODUCT_HREF('home', 'get-your-ai-phone') : '#final-form'
  }, "Obtenez votre AI Phone"))));
}
Object.assign(window, {
  Section: Section,
  Head: Head,
  Nav: Nav,
  TypedHeadline: TypedHeadline,
  Hero: Hero,
  ProofStrip: ProofStrip,
  Problem: Problem,
  FounderInsight: FounderInsight,
  InMarketingSystem: InMarketingSystem,
  InMarketingCopy: InMarketingCopy,
  InMarketingBlock: InMarketingBlock,
  A: A,
  ICONS: ICONS,
  PAT: PAT
});